export default {
    "en": {
        "aiImageResizer": {
            "title": "Free AI Image Resizer - Resize Photos Online | WeryAI",
            "description": "Resize images for Instagram, TikTok, YouTube and more without cropping. AI fills the extended area seamlessly. Free credits on signup, no card needed.",
            "keywords": "image resizer, resize image online, change image aspect ratio, uncrop image, resize photo for social media, instagram photo resize, tiktok image size, WeryAI",
            "og_title": "Free AI Image Resizer - Resize Photos Online | WeryAI",
            "og_description": "Resize images for Instagram, TikTok, YouTube and more without cropping. AI fills the extended area seamlessly. Free credits on signup, no card needed.",
            "twitter_title": "Free AI Image Resizer - Resize Photos Online | WeryAI",
            "twitter_description": "Resize images for Instagram, TikTok, YouTube and more without cropping. AI fills the extended area seamlessly. Free credits on signup, no card needed.",
            "page": {
                "title1": "Free AI Image Resizer for Social Media",
                "title2": "Resize photos for Instagram, TikTok, YouTube, and more without awkward crops. WeryAI keeps the subject centered and uses AI outpainting to fill the extra space naturally for each format.",
                "faq": [
                    {
                        "question": "How do I resize an image without cropping?",
                        "answer": "Use WeryAI's AI Image Resizer. Upload your photo, select the target aspect ratio (e.g., 9:16), and the AI will automatically outpaint the missing background areas instead of cropping your image."
                    },
                    {
                        "question": "What is AI Outpainting?",
                        "answer": "Outpainting is a generative AI technology that expands the borders of an image by predicting and drawing new content that matches the original style, effectively \"uncropping\" the photo. Need to extend the image with AI-generated content? Try our <a href=\"/ai-image-extender\">Image Extender</a>."
                    },
                    {
                        "question": "Can I turn a horizontal photo into a vertical one?",
                        "answer": "Yes! Simply upload your horizontal (landscape) photo and select the 9:16 ratio. The AI will extend the top and bottom of the image to fill the vertical frame."
                    },
                    {
                        "question": "Will the expanded background look fake?",
                        "answer": "WeryAI uses advanced generative models trained on massive datasets to ensure the extended background blends naturally with the original lighting and texture."
                    },
                    {
                        "question": "Can I use WeryAI AI Image Resizer for free?",
                        "answer": "Yes. New users get free credits on signup with no credit card required. You can also earn more free credits through daily check-in, completing tasks, and inviting friends, so you can keep using the tool without an upfront payment."
                    }
                ]
            },
            "faq": [
                {
                    "question": "How do I resize an image without cropping?",
                    "answer": "Use WeryAI's AI Image Resizer. Upload your photo, select the target aspect ratio (e.g., 9:16), and the AI will automatically outpaint the missing background areas instead of cropping your image."
                },
                {
                    "question": "What is AI Outpainting?",
                    "answer": "Outpainting is a generative AI technology that expands the borders of an image by predicting and drawing new content that matches the original style, effectively 'uncropping' the photo."
                },
                {
                    "question": "Can I turn a horizontal photo into a vertical one?",
                    "answer": "Yes! Simply upload your horizontal (landscape) photo and select the 9:16 ratio. The AI will extend the top and bottom of the image to fill the vertical frame."
                },
                {
                    "question": "Will the expanded background look fake?",
                    "answer": "WeryAI uses advanced generative models trained on massive datasets to ensure the extended background blends naturally with the original lighting and texture."
                },
                {
                    "question": "Can I use WeryAI AI Image Resizer for free?",
                    "answer": "Yes. New users get free credits on signup with no credit card required. You can also earn more free credits through daily check-in, completing tasks, and inviting friends, so you can keep using the tool without an upfront payment."
                }
            ],
            "feature_title1": "Smart Background Extension",
            "feature_desc1": "Magic Outpainting: The AI understands the context of your image and paints new pixels beyond the original borders. Expand landscapes, rooms, or textures seamlessly to fill the frame.",
            "feature_title2": "Center Stage Protection",
            "feature_desc2": "Never Crop the Subject: Our AI automatically identifies the main person or object and locks them in the center, ensuring they are never cut off during the resizing process.",
            "feature_title3": "Social Media Ready",
            "feature_desc3": "One-click presets for Instagram Stories (9:16), YouTube Thumbnails (16:9), and Posts (4:5). Repurpose your content across all platforms instantly.",
            "howto": {
                "name": "How to Resize Images for Any Aspect Ratio",
                "step1": {
                    "name": "Upload Image",
                    "text": "Upload your photo to WeryAI Image Resizer."
                },
                "step2": {
                    "name": "Select Ratio",
                    "text": "Choose a new aspect ratio larger than the original (e.g., 9:16 for TikTok)."
                },
                "step3": {
                    "name": "AI Generate",
                    "text": "Click 'Create'. The AI will resize the canvas and fill the extra space with generated background details."
                }
            }
        }
    },
    "zh": {
        "aiImageResizer": {
            "title": "免费 AI 图片缩放工具 - 在线调整尺寸 | WeryAI",
            "description": "为 Instagram、TikTok、YouTube 等平台调整图片尺寸，无需反复裁剪。AI 会智能延展背景并保留主体构图。注册即送免费积分，无需绑卡。",
            "keywords": "图片缩放, 调整图片尺寸, 改变图片比例, 无裁剪改尺寸, 社交媒体图片尺寸, Instagram 图片尺寸, TikTok 图片尺寸, WeryAI",
            "og_title": "免费 AI 图片缩放工具 - 在线调整尺寸 | WeryAI",
            "og_description": "为 Instagram、TikTok、YouTube 等平台调整图片尺寸，无需反复裁剪。AI 会智能延展背景并保留主体构图。注册即送免费积分，无需绑卡。",
            "twitter_title": "免费 AI 图片缩放工具 - 在线调整尺寸 | WeryAI",
            "twitter_description": "为 Instagram、TikTok、YouTube 等平台调整图片尺寸，无需反复裁剪。AI 会智能延展背景并保留主体构图。注册即送免费积分，无需绑卡。",
            "page": {
                "title1": "免费 AI 图片缩放工具，智能改尺寸不裁切",
                "title2": "为不同平台适配图片尺寸时，不必再牺牲主体构图。WeryAI 会自动识别主体，并用 AI 智能补全空白区域，让图片自然适配 9:16、1:1、16:9 等常用比例。",
                "faq": [
                    {
                        "question": "如何在不裁剪的情况下调整图像尺寸？",
                        "answer": "使用 WeryAI 的 AI 图片缩放工具。上传图片后选择目标宽高比（例如 9:16），AI 会自动补全缺失的背景区域，而不是直接裁掉原图内容。"
                    },
                    {
                        "question": "什么是 AI 扩展？",
                        "answer": "扩展是一种生成式 AI 技术，通过预测和绘制与原始风格匹配的新内容来扩展图像的边界，有效地\"取消裁剪\"照片。"
                    },
                    {
                        "question": "我可以将横向照片转换为纵向照片吗？",
                        "answer": "可以！只需上传您的横向（风景）照片并选择 9:16 比例。AI 将扩展图像的顶部和底部以填充纵向框架。"
                    },
                    {
                        "question": "扩展的背景看起来会假吗？",
                        "answer": "WeryAI 使用在大型数据集上训练的高级生成模型，确保扩展的背景与原始光照和纹理自然融合。"
                    },
                    {
                        "question": "这个工具可以免费使用吗？",
                        "answer": "可以。新用户注册即可获得免费积分，无需信用卡。你还可以通过每日签到、完成任务和邀请好友获得更多免费积分，因此无需预付费也能继续使用图片缩放工具。"
                    }
                ]
            },
            "faq": [
                {
                    "question": "如何在不裁剪的情况下调整图像尺寸？",
                    "answer": "使用 WeryAI 的 AI 图片缩放工具。上传图片后选择目标宽高比（例如 9:16），AI 会自动补全缺失的背景区域，而不是直接裁掉原图内容。"
                },
                {
                    "question": "什么是 AI 扩展？",
                    "answer": "扩展是一种生成式 AI 技术，通过预测和绘制与原始风格匹配的新内容来扩展图像的边界，有效地\"取消裁剪\"照片。"
                },
                {
                    "question": "我可以将横向照片转换为纵向照片吗？",
                    "answer": "可以！只需上传您的横向（风景）照片并选择 9:16 比例。AI 将扩展图像的顶部和底部以填充纵向框架。"
                },
                {
                    "question": "扩展的背景看起来会假吗？",
                    "answer": "WeryAI 使用在大型数据集上训练的高级生成模型，确保扩展的背景与原始光照和纹理自然融合。"
                },
                {
                    "question": "这个工具可以免费使用吗？",
                    "answer": "可以。新用户注册即可获得免费积分，无需信用卡。你还可以通过每日签到、完成任务和邀请好友获得更多免费积分，因此无需预付费也能继续使用图片缩放工具。"
                }
            ],
            "feature_title1": "智能背景扩展",
            "feature_desc1": "魔法扩展：AI 理解您图像的上下文，并在原始边界之外绘制新像素。无缝扩展风景、房间或纹理以填充画面。",
            "feature_title2": "中心保护",
            "feature_desc2": "永不裁剪主体：我们的 AI 自动识别主要人物或物体并将其锁定在中心，确保在调整大小过程中永远不会被裁剪。",
            "feature_title3": "社交媒体就绪",
            "feature_desc3": "一键预设 Instagram Stories (9:16)、YouTube 缩略图 (16:9) 和帖子 (4:5)。立即在所有平台上重新利用您的内容。",
            "howto": {
                "name": "如何用 AI 调整图片尺寸而不裁切",
                "step1": {
                    "name": "上传图片",
                    "text": "将您的照片上传到 WeryAI 图片调整器。"
                },
                "step2": {
                    "name": "选择比例",
                    "text": "选择一个比原图更大的新宽高比（例如 TikTok 的 9:16）。"
                },
                "step3": {
                    "name": "AI 生成",
                    "text": "点击“创建”。AI 会扩展画布并智能补全空白区域，生成适配新比例的图片。"
                }
            }
        }
    },
    "ja": {
        "aiImageResizer": {
            "title": "無料 AI 画像リサイズツール | WeryAI",
            "description": "Instagram、TikTok、YouTube向けに画像をクロップせずにリサイズ。AI が背景を自然に補完し、被写体の構図を保ちます。登録で無料クレジット、カード不要。",
            "keywords": "画像リサイズ, 画像サイズ変更, アスペクト比変更, クロップなしリサイズ, SNS画像サイズ, Instagram画像サイズ, TikTok画像サイズ, WeryAI",
            "og_title": "無料 AI 画像リサイズツール | WeryAI",
            "og_description": "Instagram、TikTok、YouTube向けに画像をクロップせずにリサイズ。AI が背景を自然に補完し、被写体の構図を保ちます。登録で無料クレジット、カード不要。",
            "twitter_title": "無料 AI 画像リサイズツール | WeryAI",
            "twitter_description": "Instagram、TikTok、YouTube向けに画像をクロップせずにリサイズ。AI が背景を自然に補完し、被写体の構図を保ちます。登録で無料クレジット、カード不要。",
            "page": {
                "title1": "AIで画像サイズを調整、クロップ不要",
                "title2": "プラットフォームごとに画像比率を変えたいときも、主役を切り取る必要はありません。WeryAI は被写体を保ちながら背景を AI で補完し、9:16、1:1、16:9 などへ自然に変換します。",
                "faq": [
                    {
                        "question": "クロップせずに画像をリサイズするには？",
                        "answer": "WeryAI の AI 画像リサイズツールを使います。画像をアップロードし、目標の比率（例: 9:16）を選ぶと、AI が背景を補完して新しい比率に合わせます。"
                    },
                    {
                        "question": "画像リサイズにおける AI アウトペインティングとは？",
                        "answer": "AI アウトペインティングは、元画像の光や質感、スタイルに合わせて新しい背景領域を生成し、自然にキャンバスを広げる技術です。"
                    },
                    {
                        "question": "横長写真を縦長にできますか？",
                        "answer": "はい。横長写真をアップロードして 9:16 などの縦比率を選ぶと、AI が上下を自然に拡張します。"
                    },
                    {
                        "question": "対応しているアスペクト比は？",
                        "answer": "16:9、9:16、1:1、4:3、3:4、21:9、9:21 など、SNS や広告向けの主要な比率に対応しています。"
                    },
                    {
                        "question": "このツールは無料で使えますか？",
                        "answer": "はい。新規ユーザーは登録時に無料クレジットを受け取れ、クレジットカードも不要です。さらに、毎日のチェックイン、タスク完了、友達招待でも無料クレジットを獲得できます。"
                    }
                ]
            },
            "faq": [
                {
                    "question": "クロップせずに画像をリサイズするには？",
                    "answer": "WeryAI の AI 画像リサイズツールを使います。画像をアップロードし、目標の比率（例: 9:16）を選ぶと、AI が背景を補完して新しい比率に合わせます。"
                },
                {
                    "question": "画像リサイズにおける AI アウトペインティングとは？",
                    "answer": "AI アウトペインティングは、元画像の光や質感、スタイルに合わせて新しい背景領域を生成し、自然にキャンバスを広げる技術です。"
                },
                {
                    "question": "横長写真を縦長にできますか？",
                    "answer": "はい。横長写真をアップロードして 9:16 などの縦比率を選ぶと、AI が上下を自然に拡張します。"
                },
                {
                    "question": "対応しているアスペクト比は？",
                    "answer": "16:9、9:16、1:1、4:3、3:4、21:9、9:21 など、SNS や広告向けの主要な比率に対応しています。"
                },
                {
                    "question": "このツールは無料で使えますか？",
                    "answer": "はい。新規ユーザーは登録時に無料クレジットを受け取れ、クレジットカードも不要です。さらに、毎日のチェックイン、タスク完了、友達招待でも無料クレジットを獲得できます。"
                }
            ],
            "feature_title1": "スマート背景拡張",
            "feature_desc1": "AI が画像を解析し、追加されたキャンバス領域に自然な背景を生成します。",
            "feature_title2": "被写体をしっかり保護",
            "feature_desc2": "人物や商品などの主役を中央に保ち、比率変更時の意図しない切り抜きを防ぎます。",
            "feature_title3": "SNS サイズにすぐ対応",
            "feature_desc3": "Instagram、TikTok、YouTube などの主要比率へワンクリックで調整できます。",
            "howto": {
                "name": "AI で画像を任意の比率にリサイズする方法",
                "step1": {
                    "name": "画像をアップロード",
                    "text": "WeryAI に画像をアップロードします。"
                },
                "step2": {
                    "name": "比率を選択",
                    "text": "9:16 や 16:9 など、元画像より大きい目的の比率を選びます。"
                },
                "step3": {
                    "name": "AI 生成",
                    "text": "「作成」をクリックすると、AI がキャンバスを広げて不足する背景を補完します。"
                }
            }
        }
    },
    "ko": {
        "aiImageResizer": {
            "title": "무료 AI 이미지 리사이저 - 온라인 크기 조정 | WeryAI",
            "description": "Instagram, TikTok, YouTube용 이미지를 자르지 않고 리사이즈하세요. AI가 배경을 자연스럽게 확장하고 피사체 구도를 유지합니다. 가입 시 무료 크레딧 제공, 카드 불필요.",
            "keywords": "이미지 리사이즈, 이미지 크기 조정, 비율 변경, 자르지 않는 리사이즈, SNS 이미지 크기, Instagram 이미지 크기, TikTok 이미지 크기, WeryAI",
            "og_title": "무료 AI 이미지 리사이저 - 온라인 크기 조정 | WeryAI",
            "og_description": "Instagram, TikTok, YouTube용 이미지를 자르지 않고 리사이즈하세요. AI가 배경을 자연스럽게 확장하고 피사체 구도를 유지합니다. 가입 시 무료 크레딧 제공, 카드 불필요.",
            "twitter_title": "무료 AI 이미지 리사이저 - 온라인 크기 조정 | WeryAI",
            "twitter_description": "Instagram, TikTok, YouTube용 이미지를 자르지 않고 리사이즈하세요. AI가 배경을 자연스럽게 확장하고 피사체 구도를 유지합니다. 가입 시 무료 크레딧 제공, 카드 불필요.",
            "page": {
                "title1": "AI로 이미지 크기 조정, 크롭 없이 자연스럽게",
                "title2": "플랫폼에 맞게 비율을 바꾸더라도 중요한 피사체를 잘라낼 필요가 없습니다. WeryAI는 피사체를 유지하고 AI 아웃페인팅으로 빈 공간을 자연스럽게 채웁니다.",
                "faq": [
                    {
                        "question": "이미지를 자르지 않고 리사이즈하려면 어떻게 하나요?",
                        "answer": "WeryAI의 AI 이미지 리사이저를 사용하세요. 사진을 업로드하고 목표 비율(예: 9:16)을 선택하면 AI가 잘라내는 대신 부족한 배경을 자동으로 확장합니다."
                    },
                    {
                        "question": "이미지 리사이즈에서 AI 아웃페인팅이란 무엇인가요?",
                        "answer": "AI 아웃페인팅은 원본 이미지의 조명, 질감, 스타일에 맞춰 새로운 배경 영역을 생성해 캔버스를 자연스럽게 확장하는 기술입니다."
                    },
                    {
                        "question": "가로 사진을 세로 사진으로 바꿀 수 있나요?",
                        "answer": "네. 가로 사진을 업로드하고 9:16 같은 세로 비율을 선택하면 AI가 위아래 영역을 자연스럽게 확장합니다."
                    },
                    {
                        "question": "어떤 종횡비를 지원하나요?",
                        "answer": "16:9, 9:16, 1:1, 4:3, 3:4, 21:9, 9:21 등 SNS와 광고에 자주 쓰이는 주요 비율을 지원합니다."
                    },
                    {
                        "question": "이 도구를 무료로 사용할 수 있나요?",
                        "answer": "네. 신규 사용자는 가입 시 신용카드 없이 무료 크레딧을 받을 수 있습니다. 또한 매일 체크인, 작업 완료, 친구 초대를 통해 무료 크레딧을 더 받을 수 있습니다."
                    }
                ]
            },
            "faq": [
                {
                    "question": "이미지를 자르지 않고 리사이즈하려면 어떻게 하나요?",
                    "answer": "WeryAI의 AI 이미지 리사이저를 사용하세요. 사진을 업로드하고 목표 비율(예: 9:16)을 선택하면 AI가 잘라내는 대신 부족한 배경을 자동으로 확장합니다."
                },
                {
                    "question": "이미지 리사이즈에서 AI 아웃페인팅이란 무엇인가요?",
                    "answer": "AI 아웃페인팅은 원본 이미지의 조명, 질감, 스타일에 맞춰 새로운 배경 영역을 생성해 캔버스를 자연스럽게 확장하는 기술입니다."
                },
                {
                    "question": "가로 사진을 세로 사진으로 바꿀 수 있나요?",
                    "answer": "네. 가로 사진을 업로드하고 9:16 같은 세로 비율을 선택하면 AI가 위아래 영역을 자연스럽게 확장합니다."
                },
                {
                    "question": "어떤 종횡비를 지원하나요?",
                    "answer": "16:9, 9:16, 1:1, 4:3, 3:4, 21:9, 9:21 등 SNS와 광고에 자주 쓰이는 주요 비율을 지원합니다."
                },
                {
                    "question": "이 도구를 무료로 사용할 수 있나요?",
                    "answer": "네. 신규 사용자는 가입 시 신용카드 없이 무료 크레딧을 받을 수 있습니다. 또한 매일 체크인, 작업 완료, 친구 초대를 통해 무료 크레딧을 더 받을 수 있습니다."
                }
            ],
            "feature_title1": "스마트 배경 확장",
            "feature_desc1": "AI가 장면을 분석하고 새 캔버스 영역에 자연스럽게 어울리는 배경을 생성합니다.",
            "feature_title2": "피사체 중심 보호",
            "feature_desc2": "인물, 제품, 주요 피사체가 중앙에 유지되어 비율 변경 중 잘리지 않습니다.",
            "feature_title3": "소셜 미디어용 프리셋",
            "feature_desc3": "Instagram, TikTok, YouTube 등 주요 플랫폼 비율에 맞춰 빠르게 조정할 수 있습니다.",
            "howto": {
                "name": "AI로 이미지 비율을 자연스럽게 변경하는 방법",
                "step1": {
                    "name": "이미지 업로드",
                    "text": "WeryAI에 사진을 업로드하세요."
                },
                "step2": {
                    "name": "비율 선택",
                    "text": "TikTok용 9:16, YouTube용 16:9 등 원하는 새 비율을 선택하세요."
                },
                "step3": {
                    "name": "AI 생성",
                    "text": "만들기를 클릭하면 AI가 캔버스를 확장하고 빈 공간을 배경으로 채웁니다."
                }
            }
        }
    },
    "es": {
        "aiImageResizer": {
            "title": "Redimensionar Imágenes con IA Gratis | WeryAI",
            "description": "Redimensiona imágenes para Instagram, TikTok y YouTube sin recortar. La IA amplía el fondo de forma natural y mantiene el sujeto en foco. Créditos gratis al registrarte, sin tarjeta.",
            "keywords": "redimensionar imagen, cambiar tamaño de imagen, cambiar relación de aspecto, redimensionar sin recortar, tamaño imagen redes sociales, tamaño Instagram, tamaño TikTok, WeryAI",
            "og_title": "Redimensionar Imágenes con IA Gratis | WeryAI",
            "og_description": "Redimensiona imágenes para Instagram, TikTok y YouTube sin recortar. La IA amplía el fondo de forma natural y mantiene el sujeto en foco. Créditos gratis al registrarte, sin tarjeta.",
            "twitter_title": "Redimensionar Imágenes con IA Gratis | WeryAI",
            "twitter_description": "Redimensiona imágenes para Instagram, TikTok y YouTube sin recortar. La IA amplía el fondo de forma natural y mantiene el sujeto en foco. Créditos gratis al registrarte, sin tarjeta.",
            "page": {
                "title1": "Redimensiona imágenes sin recortar",
                "title2": "Adapta tus fotos a 9:16, 1:1, 16:9 y más sin perder al sujeto principal. WeryAI usa IA para ampliar el lienzo y rellenar el fondo con un resultado natural.",
                "faq": [
                    {
                        "question": "¿Cómo redimensiono una imagen sin recortar?",
                        "answer": "Usa el Redimensionador de Imágenes con IA de WeryAI. Sube tu foto, elige la proporción de destino y la IA ampliará las zonas faltantes del fondo en lugar de recortar la imagen."
                    },
                    {
                        "question": "¿Qué es el outpainting con IA al redimensionar imágenes?",
                        "answer": "El outpainting con IA amplía el lienzo generando nuevo contenido de fondo que coincide con la luz, la textura y el estilo de la imagen original."
                    },
                    {
                        "question": "¿Puedo convertir una foto horizontal en vertical?",
                        "answer": "Sí. Sube una foto horizontal y elige una proporción vertical como 9:16. La IA ampliará la parte superior e inferior para ajustarla."
                    },
                    {
                        "question": "¿Qué proporciones se admiten?",
                        "answer": "Admitimos 16:9, 9:16, 1:1, 4:3, 3:4, 21:9 y 9:21 para redes sociales, anuncios y reutilización de contenido."
                    },
                    {
                        "question": "¿Puedo usar WeryAI Image Resizer gratis?",
                        "answer": "Sí. Los nuevos usuarios reciben créditos gratis al registrarse sin necesidad de tarjeta de crédito. También puedes conseguir más créditos gratis con el check-in diario, completando tareas e invitando amigos."
                    }
                ]
            },
            "faq": [
                {
                    "question": "¿Cómo redimensiono una imagen sin recortar?",
                    "answer": "Usa el Redimensionador de Imágenes con IA de WeryAI. Sube tu foto, elige la proporción de destino y la IA ampliará las zonas faltantes del fondo en lugar de recortar la imagen."
                },
                {
                    "question": "¿Qué es el outpainting con IA al redimensionar imágenes?",
                    "answer": "El outpainting con IA amplía el lienzo generando nuevo contenido de fondo que coincide con la luz, la textura y el estilo de la imagen original."
                },
                {
                    "question": "¿Puedo convertir una foto horizontal en vertical?",
                    "answer": "Sí. Sube una foto horizontal y elige una proporción vertical como 9:16. La IA ampliará la parte superior e inferior para ajustarla."
                },
                {
                    "question": "¿Qué proporciones se admiten?",
                    "answer": "Admitimos 16:9, 9:16, 1:1, 4:3, 3:4, 21:9 y 9:21 para redes sociales, anuncios y reutilización de contenido."
                },
                {
                    "question": "¿Puedo usar WeryAI Image Resizer gratis?",
                    "answer": "Sí. Los nuevos usuarios reciben créditos gratis al registrarse sin necesidad de tarjeta de crédito. También puedes conseguir más créditos gratis con el check-in diario, completando tareas e invitando amigos."
                }
            ],
            "feature_title1": "Extensión inteligente del fondo",
            "feature_desc1": "La IA analiza la escena y rellena el espacio extra con un fondo coherente con la imagen original.",
            "feature_title2": "Protección del sujeto principal",
            "feature_desc2": "Personas, productos y objetos importantes se mantienen centrados y no se recortan por accidente.",
            "feature_title3": "Listo para redes sociales",
            "feature_desc3": "Adapta una sola imagen a Instagram, TikTok, YouTube y más con proporciones predefinidas.",
            "howto": {
                "name": "Cómo redimensionar imágenes para cualquier proporción",
                "step1": {
                    "name": "Sube la imagen",
                    "text": "Sube tu foto a WeryAI Image Resizer."
                },
                "step2": {
                    "name": "Elige la proporción",
                    "text": "Selecciona una nueva proporción mayor que la original, como 9:16 o 16:9."
                },
                "step3": {
                    "name": "Generar con IA",
                    "text": "Haz clic en Crear. La IA ampliará el lienzo y rellenará el espacio extra con detalles de fondo."
                }
            }
        }
    },
    "fr": {
        "aiImageResizer": {
            "title": "Redimensionner Images par IA Gratuit | WeryAI",
            "description": "Redimensionnez vos images pour Instagram, TikTok et YouTube sans recadrer. L’IA étend naturellement l’arrière-plan et conserve le sujet principal. Crédits gratuits à l’inscription, sans carte.",
            "keywords": "redimensionner image, changer taille image, changer ratio image, redimensionner sans recadrer, taille image réseaux sociaux, taille Instagram, taille TikTok, WeryAI",
            "og_title": "Redimensionner Images par IA Gratuit | WeryAI",
            "og_description": "Redimensionnez vos images pour Instagram, TikTok et YouTube sans recadrer. L’IA étend naturellement l’arrière-plan et conserve le sujet principal. Crédits gratuits à l’inscription, sans carte.",
            "twitter_title": "Redimensionner Images par IA Gratuit | WeryAI",
            "twitter_description": "Redimensionnez vos images pour Instagram, TikTok et YouTube sans recadrer. L’IA étend naturellement l’arrière-plan et conserve le sujet principal. Crédits gratuits à l’inscription, sans carte.",
            "page": {
                "title1": "Redimensionnez vos images sans recadrage",
                "title2": "Passez facilement en 9:16, 1:1, 16:9 et plus encore sans couper le sujet. WeryAI utilise l’IA pour étendre la toile et recréer un fond naturel.",
                "faq": [
                    {
                        "question": "Comment redimensionner une image sans recadrer ?",
                        "answer": "Utilisez le redimensionneur d’images IA de WeryAI. Importez votre photo, choisissez le ratio cible, puis l’IA étendra les zones manquantes du fond au lieu de couper l’image."
                    },
                    {
                        "question": "Qu’est-ce que l’outpainting IA pour le redimensionnement ?",
                        "answer": "L’outpainting IA agrandit la toile en générant un nouveau fond cohérent avec la lumière, la texture et le style de l’image originale."
                    },
                    {
                        "question": "Puis-je transformer une photo horizontale en verticale ?",
                        "answer": "Oui. Importez votre photo horizontale et choisissez un format vertical comme 9:16. L’IA étendra naturellement le haut et le bas."
                    },
                    {
                        "question": "Quels ratios sont pris en charge ?",
                        "answer": "Nous prenons en charge 16:9, 9:16, 1:1, 4:3, 3:4, 21:9 et 9:21 pour les réseaux sociaux, les publicités et les contenus multiformats."
                    },
                    {
                        "question": "Puis-je utiliser WeryAI Image Resizer gratuitement ?",
                        "answer": "Oui. Les nouveaux utilisateurs reçoivent des crédits gratuits à l’inscription, sans carte bancaire. Vous pouvez aussi obtenir plus de crédits gratuits grâce à la connexion quotidienne, aux tâches terminées et aux invitations d’amis."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Comment redimensionner une image sans recadrer ?",
                    "answer": "Utilisez le redimensionneur d’images IA de WeryAI. Importez votre photo, choisissez le ratio cible, puis l’IA étendra les zones manquantes du fond au lieu de couper l’image."
                },
                {
                    "question": "Qu’est-ce que l’outpainting IA pour le redimensionnement ?",
                    "answer": "L’outpainting IA agrandit la toile en générant un nouveau fond cohérent avec la lumière, la texture et le style de l’image originale."
                },
                {
                    "question": "Puis-je transformer une photo horizontale en verticale ?",
                    "answer": "Oui. Importez votre photo horizontale et choisissez un format vertical comme 9:16. L’IA étendra naturellement le haut et le bas."
                },
                {
                    "question": "Quels ratios sont pris en charge ?",
                    "answer": "Nous prenons en charge 16:9, 9:16, 1:1, 4:3, 3:4, 21:9 et 9:21 pour les réseaux sociaux, les publicités et les contenus multiformats."
                },
                {
                    "question": "Puis-je utiliser WeryAI Image Resizer gratuitement ?",
                    "answer": "Oui. Les nouveaux utilisateurs reçoivent des crédits gratuits à l’inscription, sans carte bancaire. Vous pouvez aussi obtenir plus de crédits gratuits grâce à la connexion quotidienne, aux tâches terminées et aux invitations d’amis."
                }
            ],
            "feature_title1": "Extension intelligente du fond",
            "feature_desc1": "L’IA analyse l’image et remplit l’espace ajouté avec un arrière-plan naturel et cohérent.",
            "feature_title2": "Protection du sujet principal",
            "feature_desc2": "Le sujet reste centré pour éviter les recadrages accidentels sur les personnes, produits ou objets importants.",
            "feature_title3": "Prêt pour les réseaux sociaux",
            "feature_desc3": "Ajustez une image pour Instagram, TikTok, YouTube et d’autres formats populaires en quelques clics.",
            "howto": {
                "name": "Comment redimensionner des images pour n’importe quel format",
                "step1": {
                    "name": "Importer une image",
                    "text": "Importez votre photo dans WeryAI Image Resizer."
                },
                "step2": {
                    "name": "Choisir le ratio",
                    "text": "Sélectionnez un nouveau ratio plus grand que l’original, comme 9:16 ou 16:9."
                },
                "step3": {
                    "name": "Générer avec l’IA",
                    "text": "Cliquez sur Créer. L’IA agrandit la toile et remplit l’espace supplémentaire avec des détails d’arrière-plan."
                }
            }
        }
    },
    "de": {
        "aiImageResizer": {
            "title": "Kostenloser KI-Bild-Resizer Online | WeryAI",
            "description": "Ändern Sie die Bildgröße für Instagram, TikTok und YouTube ohne Zuschneiden. Die KI erweitert den Hintergrund natürlich und hält das Hauptmotiv im Fokus. Kostenlose Credits bei der Registrierung, keine Karte nötig.",
            "keywords": "bildgröße ändern, bild resizer, seitenverhältnis ändern, ohne zuschneiden skalieren, social media bildgröße, Instagram bildgröße, TikTok bildgröße, WeryAI",
            "og_title": "Kostenloser KI-Bild-Resizer Online | WeryAI",
            "og_description": "Ändern Sie die Bildgröße für Instagram, TikTok und YouTube ohne Zuschneiden. Die KI erweitert den Hintergrund natürlich und hält das Hauptmotiv im Fokus. Kostenlose Credits bei der Registrierung, keine Karte nötig.",
            "twitter_title": "Kostenloser KI-Bild-Resizer Online | WeryAI",
            "twitter_description": "Ändern Sie die Bildgröße für Instagram, TikTok und YouTube ohne Zuschneiden. Die KI erweitert den Hintergrund natürlich und hält das Hauptmotiv im Fokus. Kostenlose Credits bei der Registrierung, keine Karte nötig.",
            "page": {
                "title1": "Bilder ohne Zuschneiden skalieren",
                "title2": "Passen Sie Fotos an 9:16, 1:1, 16:9 und weitere Formate an, ohne das Hauptmotiv abzuschneiden. WeryAI erweitert die Leinwand per KI und ergänzt den Hintergrund natürlich.",
                "faq": [
                    {
                        "question": "Wie ändere ich die Bildgröße ohne Zuschneiden?",
                        "answer": "Nutzen Sie den KI-Bild-Resizer von WeryAI. Laden Sie Ihr Bild hoch, wählen Sie das Zielseitenverhältnis und die KI erweitert fehlende Hintergrundbereiche statt das Bild zu beschneiden."
                    },
                    {
                        "question": "Was ist KI-Outpainting beim Bild-Resizing?",
                        "answer": "KI-Outpainting vergrößert die Leinwand und erzeugt neuen Hintergrund, der zu Licht, Struktur und Stil des Originalbildes passt."
                    },
                    {
                        "question": "Kann ich ein horizontales Foto in ein vertikales umwandeln?",
                        "answer": "Ja. Laden Sie ein Querformat hoch und wählen Sie ein Hochformat wie 9:16. Die KI erweitert den oberen und unteren Bereich automatisch."
                    },
                    {
                        "question": "Welche Seitenverhältnisse werden unterstützt?",
                        "answer": "Unterstützt werden 16:9, 9:16, 1:1, 4:3, 3:4, 21:9 und 9:21 für Social Media, Anzeigen und Content-Recycling."
                    },
                    {
                        "question": "Kann ich WeryAI Image Resizer kostenlos nutzen?",
                        "answer": "Ja. Neue Nutzer erhalten bei der Registrierung kostenlose Credits, ganz ohne Kreditkarte. Zusätzlich können Sie durch tägliches Einchecken, Aufgaben und Einladungen weitere kostenlose Credits erhalten."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Wie ändere ich die Bildgröße ohne Zuschneiden?",
                    "answer": "Nutzen Sie den KI-Bild-Resizer von WeryAI. Laden Sie Ihr Bild hoch, wählen Sie das Zielseitenverhältnis und die KI erweitert fehlende Hintergrundbereiche statt das Bild zu beschneiden."
                },
                {
                    "question": "Was ist KI-Outpainting beim Bild-Resizing?",
                    "answer": "KI-Outpainting vergrößert die Leinwand und erzeugt neuen Hintergrund, der zu Licht, Struktur und Stil des Originalbildes passt."
                },
                {
                    "question": "Kann ich ein horizontales Foto in ein vertikales umwandeln?",
                    "answer": "Ja. Laden Sie ein Querformat hoch und wählen Sie ein Hochformat wie 9:16. Die KI erweitert den oberen und unteren Bereich automatisch."
                },
                {
                    "question": "Welche Seitenverhältnisse werden unterstützt?",
                    "answer": "Unterstützt werden 16:9, 9:16, 1:1, 4:3, 3:4, 21:9 und 9:21 für Social Media, Anzeigen und Content-Recycling."
                },
                {
                    "question": "Kann ich WeryAI Image Resizer kostenlos nutzen?",
                    "answer": "Ja. Neue Nutzer erhalten bei der Registrierung kostenlose Credits, ganz ohne Kreditkarte. Zusätzlich können Sie durch tägliches Einchecken, Aufgaben und Einladungen weitere kostenlose Credits erhalten."
                }
            ],
            "feature_title1": "Intelligente Hintergrunderweiterung",
            "feature_desc1": "Die KI analysiert die Szene und füllt den zusätzlichen Bildraum mit natürlich passenden Hintergrunddetails.",
            "feature_title2": "Schutz des Hauptmotivs",
            "feature_desc2": "Wichtige Personen, Produkte oder Objekte bleiben im Zentrum und werden beim Formatwechsel nicht versehentlich abgeschnitten.",
            "feature_title3": "Für Social Media optimiert",
            "feature_desc3": "Passen Sie ein Bild schnell an Instagram, TikTok, YouTube und andere gängige Formate an.",
            "howto": {
                "name": "So skalieren Sie Bilder für jedes Seitenverhältnis",
                "step1": {
                    "name": "Bild hochladen",
                    "text": "Laden Sie Ihr Foto in WeryAI Image Resizer hoch."
                },
                "step2": {
                    "name": "Verhältnis wählen",
                    "text": "Wählen Sie ein neues Seitenverhältnis, das größer als das Original ist, z. B. 9:16 oder 16:9."
                },
                "step3": {
                    "name": "Mit KI generieren",
                    "text": "Klicken Sie auf Erstellen. Die KI vergrößert die Leinwand und füllt die zusätzlichen Bereiche mit Hintergrunddetails."
                }
            }
        }
    },
    "ru": {
        "aiImageResizer": {
            "title": "Бесплатный ИИ-Ресайзер Изображений | WeryAI",
            "description": "Меняйте размер изображений для Instagram, TikTok и YouTube без обрезки. ИИ естественно расширяет фон и сохраняет главный объект. Бесплатные кредиты при регистрации, без карты.",
            "keywords": "изменить размер изображения, ресайзер изображений, смена соотношения сторон, без обрезки, размер изображения для соцсетей, размер Instagram, размер TikTok, WeryAI",
            "og_title": "Бесплатный ИИ-Ресайзер Изображений | WeryAI",
            "og_description": "Меняйте размер изображений для Instagram, TikTok и YouTube без обрезки. ИИ естественно расширяет фон и сохраняет главный объект. Бесплатные кредиты при регистрации, без карты.",
            "twitter_title": "Бесплатный ИИ-Ресайзер Изображений | WeryAI",
            "twitter_description": "Меняйте размер изображений для Instagram, TikTok и YouTube без обрезки. ИИ естественно расширяет фон и сохраняет главный объект. Бесплатные кредиты при регистрации, без карты.",
            "page": {
                "title1": "Меняйте размер без обрезки",
                "title2": "Подгоняйте фото под 9:16, 1:1, 16:9 и другие форматы, не обрезая главный объект. WeryAI расширяет холст с помощью ИИ и естественно дорисовывает фон.",
                "faq": [
                    {
                        "question": "Как изменить размер изображения без обрезки?",
                        "answer": "Используйте AI Image Resizer от WeryAI. Загрузите фото, выберите целевое соотношение сторон, и ИИ дорисует недостающий фон вместо того, чтобы обрезать изображение."
                    },
                    {
                        "question": "Что такое AI outpainting при изменении размера?",
                        "answer": "AI outpainting расширяет холст, создавая новый фон, который соответствует свету, текстуре и стилю исходного изображения."
                    },
                    {
                        "question": "Можно ли превратить горизонтальное фото в вертикальное?",
                        "answer": "Да. Загрузите горизонтальное фото и выберите вертикальный формат, например 9:16. ИИ расширит верх и низ изображения."
                    },
                    {
                        "question": "Какие соотношения сторон поддерживаются?",
                        "answer": "Поддерживаются 16:9, 9:16, 1:1, 4:3, 3:4, 21:9 и 9:21 для соцсетей, рекламы и адаптации контента."
                    },
                    {
                        "question": "Можно ли пользоваться WeryAI Image Resizer бесплатно?",
                        "answer": "Да. Новые пользователи получают бесплатные кредиты при регистрации без банковской карты. Также можно получать дополнительные кредиты за ежедневные отметки, задания и приглашения друзей."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Как изменить размер изображения без обрезки?",
                    "answer": "Используйте AI Image Resizer от WeryAI. Загрузите фото, выберите целевое соотношение сторон, и ИИ дорисует недостающий фон вместо того, чтобы обрезать изображение."
                },
                {
                    "question": "Что такое AI outpainting при изменении размера?",
                    "answer": "AI outpainting расширяет холст, создавая новый фон, который соответствует свету, текстуре и стилю исходного изображения."
                },
                {
                    "question": "Можно ли превратить горизонтальное фото в вертикальное?",
                    "answer": "Да. Загрузите горизонтальное фото и выберите вертикальный формат, например 9:16. ИИ расширит верх и низ изображения."
                },
                {
                    "question": "Какие соотношения сторон поддерживаются?",
                    "answer": "Поддерживаются 16:9, 9:16, 1:1, 4:3, 3:4, 21:9 и 9:21 для соцсетей, рекламы и адаптации контента."
                },
                {
                    "question": "Можно ли пользоваться WeryAI Image Resizer бесплатно?",
                    "answer": "Да. Новые пользователи получают бесплатные кредиты при регистрации без банковской карты. Также можно получать дополнительные кредиты за ежедневные отметки, задания и приглашения друзей."
                }
            ],
            "feature_title1": "Умное расширение фона",
            "feature_desc1": "ИИ анализирует сцену и заполняет добавленное пространство фоном, который выглядит естественно рядом с оригиналом.",
            "feature_title2": "Защита главного объекта",
            "feature_desc2": "Люди, товары и важные объекты остаются в центре и не обрезаются случайно при смене формата.",
            "feature_title3": "Готово для соцсетей",
            "feature_desc3": "Быстро адаптируйте одно изображение под Instagram, TikTok, YouTube и другие популярные форматы.",
            "howto": {
                "name": "Как изменить размер изображения под любой формат",
                "step1": {
                    "name": "Загрузите изображение",
                    "text": "Загрузите фото в WeryAI Image Resizer."
                },
                "step2": {
                    "name": "Выберите формат",
                    "text": "Выберите новое соотношение сторон больше исходного, например 9:16 или 16:9."
                },
                "step3": {
                    "name": "Сгенерируйте с ИИ",
                    "text": "Нажмите «Создать». ИИ расширит холст и заполнит дополнительное пространство деталями фона."
                }
            }
        }
    },
    "pt": {
        "aiImageResizer": {
            "title": "Redimensionar Imagens com IA Grátis | WeryAI",
            "description": "Redimensione imagens para Instagram, TikTok e YouTube sem recortar. A IA amplia o fundo de forma natural e mantém o assunto em destaque. Créditos grátis ao se cadastrar, sem cartão.",
            "keywords": "redimensionar imagem, alterar tamanho da imagem, mudar proporção, redimensionar sem recortar, tamanho imagem redes sociais, tamanho Instagram, tamanho TikTok, WeryAI",
            "og_title": "Redimensionar Imagens com IA Grátis | WeryAI",
            "og_description": "Redimensione imagens para Instagram, TikTok e YouTube sem recortar. A IA amplia o fundo de forma natural e mantém o assunto em destaque. Créditos grátis ao se cadastrar, sem cartão.",
            "twitter_title": "Redimensionar Imagens com IA Grátis | WeryAI",
            "twitter_description": "Redimensione imagens para Instagram, TikTok e YouTube sem recortar. A IA amplia o fundo de forma natural e mantém o assunto em destaque. Créditos grátis ao se cadastrar, sem cartão.",
            "page": {
                "title1": "Redimensione imagens sem recortar",
                "title2": "Adapte suas fotos para 9:16, 1:1, 16:9 e muito mais sem cortar o assunto principal. O WeryAI amplia a tela com IA e recria o fundo de forma natural.",
                "faq": [
                    {
                        "question": "Como redimensionar uma imagem sem recortar?",
                        "answer": "Use o redimensionador de imagens com IA da WeryAI. Envie sua foto, escolha a proporção de destino e a IA ampliará as áreas de fundo em vez de cortar a imagem."
                    },
                    {
                        "question": "O que é outpainting com IA no redimensionamento?",
                        "answer": "O outpainting com IA amplia a tela gerando novo conteúdo de fundo que combina com a luz, a textura e o estilo da imagem original."
                    },
                    {
                        "question": "Posso transformar uma foto horizontal em vertical?",
                        "answer": "Sim. Envie uma foto horizontal e escolha um formato vertical como 9:16. A IA expandirá as áreas superior e inferior automaticamente."
                    },
                    {
                        "question": "Quais proporções são suportadas?",
                        "answer": "Suportamos 16:9, 9:16, 1:1, 4:3, 3:4, 21:9 e 9:21 para redes sociais, anúncios e reaproveitamento de conteúdo."
                    },
                    {
                        "question": "Posso usar o WeryAI Image Resizer de graça?",
                        "answer": "Sim. Novos usuários recebem créditos grátis ao se cadastrar, sem precisar de cartão de crédito. Você também pode ganhar mais créditos com check-in diário, tarefas concluídas e convites de amigos."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Como redimensionar uma imagem sem recortar?",
                    "answer": "Use o redimensionador de imagens com IA da WeryAI. Envie sua foto, escolha a proporção de destino e a IA ampliará as áreas de fundo em vez de cortar a imagem."
                },
                {
                    "question": "O que é outpainting com IA no redimensionamento?",
                    "answer": "O outpainting com IA amplia a tela gerando novo conteúdo de fundo que combina com a luz, a textura e o estilo da imagem original."
                },
                {
                    "question": "Posso transformar uma foto horizontal em vertical?",
                    "answer": "Sim. Envie uma foto horizontal e escolha um formato vertical como 9:16. A IA expandirá as áreas superior e inferior automaticamente."
                },
                {
                    "question": "Quais proporções são suportadas?",
                    "answer": "Suportamos 16:9, 9:16, 1:1, 4:3, 3:4, 21:9 e 9:21 para redes sociais, anúncios e reaproveitamento de conteúdo."
                },
                {
                    "question": "Posso usar o WeryAI Image Resizer de graça?",
                    "answer": "Sim. Novos usuários recebem créditos grátis ao se cadastrar, sem precisar de cartão de crédito. Você também pode ganhar mais créditos com check-in diário, tarefas concluídas e convites de amigos."
                }
            ],
            "feature_title1": "Extensão inteligente do fundo",
            "feature_desc1": "A IA analisa a cena e preenche o espaço extra com um fundo que combina naturalmente com a imagem original.",
            "feature_title2": "Proteção do assunto principal",
            "feature_desc2": "Pessoas, produtos e objetos importantes permanecem centrados e não são cortados por acidente.",
            "feature_title3": "Pronto para redes sociais",
            "feature_desc3": "Ajuste rapidamente a mesma imagem para Instagram, TikTok, YouTube e outros formatos populares.",
            "howto": {
                "name": "Como redimensionar imagens para qualquer proporção",
                "step1": {
                    "name": "Enviar imagem",
                    "text": "Envie sua foto para o WeryAI Image Resizer."
                },
                "step2": {
                    "name": "Escolher proporção",
                    "text": "Selecione uma nova proporção maior que a original, como 9:16 ou 16:9."
                },
                "step3": {
                    "name": "Gerar com IA",
                    "text": "Clique em Criar. A IA ampliará a tela e preencherá o espaço extra com detalhes de fundo."
                }
            }
        }
    },
    "it": {
        "aiImageResizer": {
            "title": "Ridimensionare Immagini con IA Gratis | WeryAI",
            "description": "Ridimensiona immagini per Instagram, TikTok e YouTube senza ritagliare. L’IA estende lo sfondo in modo naturale e mantiene il soggetto al centro. Crediti gratuiti alla registrazione, senza carta.",
            "keywords": "ridimensionare immagine, cambiare dimensione immagine, cambiare proporzioni, ridimensionare senza ritagliare, dimensione immagine social, dimensione Instagram, dimensione TikTok, WeryAI",
            "og_title": "Ridimensionare Immagini con IA Gratis | WeryAI",
            "og_description": "Ridimensiona immagini per Instagram, TikTok e YouTube senza ritagliare. L’IA estende lo sfondo in modo naturale e mantiene il soggetto al centro. Crediti gratuiti alla registrazione, senza carta.",
            "twitter_title": "Ridimensionare Immagini con IA Gratis | WeryAI",
            "twitter_description": "Ridimensiona immagini per Instagram, TikTok e YouTube senza ritagliare. L’IA estende lo sfondo in modo naturale e mantiene il soggetto al centro. Crediti gratuiti alla registrazione, senza carta.",
            "page": {
                "title1": "Ridimensiona immagini senza ritagliare",
                "title2": "Adatta le tue foto a 9:16, 1:1, 16:9 e altri formati senza tagliare il soggetto principale. WeryAI amplia la tela con l’IA e ricrea lo sfondo in modo naturale.",
                "faq": [
                    {
                        "question": "Come ridimensionare un’immagine senza ritagliare?",
                        "answer": "Usa l’AI Image Resizer di WeryAI. Carica la foto, scegli il rapporto di destinazione e l’IA estenderà le aree mancanti dello sfondo invece di ritagliare l’immagine."
                    },
                    {
                        "question": "Che cos’è l’AI outpainting nel ridimensionamento delle immagini?",
                        "answer": "L’AI outpainting amplia la tela generando nuovo contenuto di sfondo coerente con luce, texture e stile dell’immagine originale."
                    },
                    {
                        "question": "Posso trasformare una foto orizzontale in verticale?",
                        "answer": "Sì. Carica una foto orizzontale e scegli un formato verticale come 9:16. L’IA espanderà automaticamente la parte superiore e inferiore."
                    },
                    {
                        "question": "Quali proporzioni sono supportate?",
                        "answer": "Supportiamo 16:9, 9:16, 1:1, 4:3, 3:4, 21:9 e 9:21 per social media, annunci e riutilizzo dei contenuti."
                    },
                    {
                        "question": "Posso usare WeryAI Image Resizer gratuitamente?",
                        "answer": "Sì. I nuovi utenti ricevono crediti gratuiti al momento della registrazione senza carta di credito. Inoltre, puoi ottenere altri crediti gratuiti con check-in giornaliero, attività completate e inviti agli amici."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Come ridimensionare un’immagine senza ritagliare?",
                    "answer": "Usa l’AI Image Resizer di WeryAI. Carica la foto, scegli il rapporto di destinazione e l’IA estenderà le aree mancanti dello sfondo invece di ritagliare l’immagine."
                },
                {
                    "question": "Che cos’è l’AI outpainting nel ridimensionamento delle immagini?",
                    "answer": "L’AI outpainting amplia la tela generando nuovo contenuto di sfondo coerente con luce, texture e stile dell’immagine originale."
                },
                {
                    "question": "Posso trasformare una foto orizzontale in verticale?",
                    "answer": "Sì. Carica una foto orizzontale e scegli un formato verticale come 9:16. L’IA espanderà automaticamente la parte superiore e inferiore."
                },
                {
                    "question": "Quali proporzioni sono supportate?",
                    "answer": "Supportiamo 16:9, 9:16, 1:1, 4:3, 3:4, 21:9 e 9:21 per social media, annunci e riutilizzo dei contenuti."
                },
                {
                    "question": "Posso usare WeryAI Image Resizer gratuitamente?",
                    "answer": "Sì. I nuovi utenti ricevono crediti gratuiti al momento della registrazione senza carta di credito. Inoltre, puoi ottenere altri crediti gratuiti con check-in giornaliero, attività completate e inviti agli amici."
                }
            ],
            "feature_title1": "Estensione intelligente dello sfondo",
            "feature_desc1": "L’IA analizza la scena e riempie lo spazio extra con uno sfondo coerente e naturale.",
            "feature_title2": "Protezione del soggetto principale",
            "feature_desc2": "Persone, prodotti e oggetti importanti restano centrati e non vengono tagliati accidentalmente.",
            "feature_title3": "Pronto per i social media",
            "feature_desc3": "Adatta rapidamente la stessa immagine a Instagram, TikTok, YouTube e altri formati popolari.",
            "howto": {
                "name": "Come ridimensionare immagini per qualsiasi proporzione",
                "step1": {
                    "name": "Carica immagine",
                    "text": "Carica la tua foto su WeryAI Image Resizer."
                },
                "step2": {
                    "name": "Scegli proporzione",
                    "text": "Seleziona una nuova proporzione più grande dell’originale, come 9:16 o 16:9."
                },
                "step3": {
                    "name": "Genera con IA",
                    "text": "Fai clic su Crea. L’IA espanderà la tela e riempirà lo spazio extra con dettagli di sfondo."
                }
            }
        }
    },
    "ar": {
        "aiImageResizer": {
            "title": "أداة تغيير حجم الصور بالذكاء الاصطناعي مجاناً | WeryAI",
            "description": "غيّر حجم الصور لـ Instagram وTikTok وYouTube دون قص. يوسّع الذكاء الاصطناعي الخلفية بشكل طبيعي ويحافظ على العنصر الرئيسي. رصيد مجاني عند التسجيل ومن دون بطاقة.",
            "keywords": "تغيير حجم الصورة, تغيير أبعاد الصورة, تغيير نسبة العرض إلى الارتفاع, تغيير الحجم دون قص, مقاس صور السوشيال, مقاس Instagram, مقاس TikTok, WeryAI",
            "og_title": "أداة تغيير حجم الصور بالذكاء الاصطناعي مجاناً | WeryAI",
            "og_description": "غيّر حجم الصور لـ Instagram وTikTok وYouTube دون قص. يوسّع الذكاء الاصطناعي الخلفية بشكل طبيعي ويحافظ على العنصر الرئيسي. رصيد مجاني عند التسجيل ومن دون بطاقة.",
            "twitter_title": "أداة تغيير حجم الصور بالذكاء الاصطناعي مجاناً | WeryAI",
            "twitter_description": "غيّر حجم الصور لـ Instagram وTikTok وYouTube دون قص. يوسّع الذكاء الاصطناعي الخلفية بشكل طبيعي ويحافظ على العنصر الرئيسي. رصيد مجاني عند التسجيل ومن دون بطاقة.",
            "page": {
                "title1": "غيّر حجم الصور دون قص",
                "title2": "حوّل صورك إلى 9:16 أو 1:1 أو 16:9 وغيرها من المقاسات من دون فقدان العنصر الرئيسي. يستخدم WeryAI الذكاء الاصطناعي لتوسيع اللوحة وإكمال الخلفية بشكل طبيعي.",
                "faq": [
                    {
                        "question": "كيف أغيّر حجم صورة من دون قص؟",
                        "answer": "استخدم أداة WeryAI لتغيير حجم الصور بالذكاء الاصطناعي. ارفع الصورة واختر نسبة العرض إلى الارتفاع المطلوبة، وسيقوم الذكاء الاصطناعي بتمديد الخلفية بدلاً من قص الصورة."
                    },
                    {
                        "question": "ما هو التوسيع الذكي للخلفية عند تغيير الحجم؟",
                        "answer": "يقوم الذكاء الاصطناعي بتوسيع مساحة الصورة عبر إنشاء خلفية جديدة تتوافق مع الإضاءة والملمس وأسلوب الصورة الأصلية."
                    },
                    {
                        "question": "هل يمكنني تحويل صورة أفقية إلى عمودية؟",
                        "answer": "نعم. ارفع صورة أفقية واختر نسبة عمودية مثل 9:16، وسيقوم الذكاء الاصطناعي بتوسيع الجزء العلوي والسفلي تلقائياً."
                    },
                    {
                        "question": "ما هي نسب العرض إلى الارتفاع المدعومة؟",
                        "answer": "ندعم 16:9 و9:16 و1:1 و4:3 و3:4 و21:9 و9:21 لاستخدامات السوشيال ميديا والإعلانات وإعادة توظيف المحتوى."
                    },
                    {
                        "question": "هل يمكنني استخدام WeryAI Image Resizer مجاناً؟",
                        "answer": "نعم. يحصل المستخدمون الجدد على أرصدة مجانية عند التسجيل من دون الحاجة إلى بطاقة ائتمان. ويمكنك أيضاً الحصول على المزيد من الأرصدة المجانية عبر تسجيل الدخول اليومي وإكمال المهام ودعوة الأصدقاء."
                    }
                ]
            },
            "faq": [
                {
                    "question": "كيف أغيّر حجم صورة من دون قص؟",
                    "answer": "استخدم أداة WeryAI لتغيير حجم الصور بالذكاء الاصطناعي. ارفع الصورة واختر نسبة العرض إلى الارتفاع المطلوبة، وسيقوم الذكاء الاصطناعي بتمديد الخلفية بدلاً من قص الصورة."
                },
                {
                    "question": "ما هو التوسيع الذكي للخلفية عند تغيير الحجم؟",
                    "answer": "يقوم الذكاء الاصطناعي بتوسيع مساحة الصورة عبر إنشاء خلفية جديدة تتوافق مع الإضاءة والملمس وأسلوب الصورة الأصلية."
                },
                {
                    "question": "هل يمكنني تحويل صورة أفقية إلى عمودية؟",
                    "answer": "نعم. ارفع صورة أفقية واختر نسبة عمودية مثل 9:16، وسيقوم الذكاء الاصطناعي بتوسيع الجزء العلوي والسفلي تلقائياً."
                },
                {
                    "question": "ما هي نسب العرض إلى الارتفاع المدعومة؟",
                    "answer": "ندعم 16:9 و9:16 و1:1 و4:3 و3:4 و21:9 و9:21 لاستخدامات السوشيال ميديا والإعلانات وإعادة توظيف المحتوى."
                },
                {
                    "question": "هل يمكنني استخدام WeryAI Image Resizer مجاناً؟",
                    "answer": "نعم. يحصل المستخدمون الجدد على أرصدة مجانية عند التسجيل من دون الحاجة إلى بطاقة ائتمان. ويمكنك أيضاً الحصول على المزيد من الأرصدة المجانية عبر تسجيل الدخول اليومي وإكمال المهام ودعوة الأصدقاء."
                }
            ],
            "feature_title1": "توسيع ذكي للخلفية",
            "feature_desc1": "يحلل الذكاء الاصطناعي المشهد ويملأ المساحة الإضافية بخلفية تبدو طبيعية ومتناسقة مع الصورة الأصلية.",
            "feature_title2": "حماية العنصر الرئيسي",
            "feature_desc2": "يبقى الأشخاص أو المنتجات أو العناصر المهمة في المنتصف حتى لا يتم قصها بالخطأ.",
            "feature_title3": "جاهز لمنصات التواصل",
            "feature_desc3": "اضبط الصورة نفسها بسرعة لتناسب Instagram وTikTok وYouTube وغيرها من المقاسات الشائعة.",
            "howto": {
                "name": "كيفية تغيير حجم الصور لأي نسبة عرض إلى ارتفاع",
                "step1": {
                    "name": "ارفع الصورة",
                    "text": "ارفع صورتك إلى WeryAI Image Resizer."
                },
                "step2": {
                    "name": "اختر النسبة",
                    "text": "حدد نسبة عرض إلى ارتفاع أكبر من الأصل مثل 9:16 أو 16:9."
                },
                "step3": {
                    "name": "إنشاء بالذكاء الاصطناعي",
                    "text": "انقر على إنشاء. سيقوم الذكاء الاصطناعي بتوسيع اللوحة وملء المساحة الإضافية بتفاصيل الخلفية."
                }
            }
        }
    },
    "tw": {
        "aiImageResizer": {
            "title": "免費 AI 圖片縮放工具 - 線上調整尺寸 | WeryAI",
            "description": "為 Instagram、TikTok、YouTube 等平台調整圖片尺寸，不用反覆裁切。AI 會智慧延展背景並保留主體構圖。註冊即送免費積分，無需綁卡。",
            "keywords": "圖片縮放, 調整圖片尺寸, 改變圖片比例, 不裁切改尺寸, 社群圖片尺寸, Instagram 圖片尺寸, TikTok 圖片尺寸, WeryAI",
            "og_title": "免費 AI 圖片縮放工具 - 線上調整尺寸 | WeryAI",
            "og_description": "為 Instagram、TikTok、YouTube 等平台調整圖片尺寸，不用反覆裁切。AI 會智慧延展背景並保留主體構圖。註冊即送免費積分，無需綁卡。",
            "twitter_title": "免費 AI 圖片縮放工具 - 線上調整尺寸 | WeryAI",
            "twitter_description": "為 Instagram、TikTok、YouTube 等平台調整圖片尺寸，不用反覆裁切。AI 會智慧延展背景並保留主體構圖。註冊即送免費積分，無需綁卡。",
            "page": {
                "title1": "AI 智慧調整尺寸，完美構圖不裁切",
                "title2": "為不同平台適配圖片尺寸時，不必再犧牲主體構圖。WeryAI 會自動識別主體，並用 AI 智慧補全空白區域，讓圖片自然適配 9:16、1:1、16:9 等常用比例。",
                "faq": [
                    {
                        "question": "如何在不裁切的情況下調整圖片尺寸？",
                        "answer": "使用 WeryAI 的 AI 圖片縮放工具。上傳圖片後選擇目標寬高比（例如 9:16），AI 會自動補全缺失的背景區域，而不是直接裁掉原圖內容。"
                    },
                    {
                        "question": "圖片縮放裡的 AI 外擴是什麼？",
                        "answer": "AI 外擴會在保留原圖風格、光影和紋理的前提下，智慧產生新增畫布區域的背景內容，讓圖片自然適配新的比例。"
                    },
                    {
                        "question": "我可以把橫圖變成直圖嗎？",
                        "answer": "可以。上傳橫向圖片後選擇 9:16 等直版比例，AI 會自動延展上下區域，讓圖片適配新的畫布尺寸。"
                    },
                    {
                        "question": "支援哪些寬高比？",
                        "answer": "支援 16:9、9:16、1:1、4:3、3:4、21:9、9:21 等常用比例，適合社群媒體、廣告和電商素材。"
                    },
                    {
                        "question": "這個工具可以免費使用嗎？",
                        "answer": "可以。新用戶註冊即可獲得免費積分，無需信用卡。你還可以透過每日簽到、完成任務和邀請好友獲得更多免費積分，因此無需預付費也能持續使用圖片尺寸調整工具。"
                    }
                ]
            },
            "faq": [
                {
                    "question": "如何在不裁切的情況下調整圖片尺寸？",
                    "answer": "使用 WeryAI 的 AI 圖片縮放工具。上傳圖片後選擇目標寬高比（例如 9:16），AI 會自動補全缺失的背景區域，而不是直接裁掉原圖內容。"
                },
                {
                    "question": "圖片縮放裡的 AI 外擴是什麼？",
                    "answer": "AI 外擴會在保留原圖風格、光影和紋理的前提下，智慧產生新增畫布區域的背景內容，讓圖片自然適配新的比例。"
                },
                {
                    "question": "我可以把橫圖變成直圖嗎？",
                    "answer": "可以。上傳橫向圖片後選擇 9:16 等直版比例，AI 會自動延展上下區域，讓圖片適配新的畫布尺寸。"
                },
                {
                    "question": "支援哪些寬高比？",
                    "answer": "支援 16:9、9:16、1:1、4:3、3:4、21:9、9:21 等常用比例，適合社群媒體、廣告和電商素材。"
                },
                {
                    "question": "這個工具可以免費使用嗎？",
                    "answer": "可以。新用戶註冊即可獲得免費積分，無需信用卡。你還可以透過每日簽到、完成任務和邀請好友獲得更多免費積分，因此無需預付費也能持續使用圖片尺寸調整工具。"
                }
            ],
            "feature_title1": "智慧背景延展",
            "feature_desc1": "AI 會分析畫面內容並補全新增區域，讓延展後的背景與原圖自然銜接。",
            "feature_title2": "主體始終置中",
            "feature_desc2": "系統會優先保護人物、產品或主體位置，避免在調整比例時被意外裁掉。",
            "feature_title3": "一鍵適配社群平台",
            "feature_desc3": "同一張圖片可以快速適配 Instagram、TikTok、YouTube 等平台的常用尺寸。",
            "howto": {
                "name": "如何用 AI 調整圖片尺寸而不裁切",
                "step1": {
                    "name": "上傳圖片",
                    "text": "上傳你想調整尺寸的圖片到 WeryAI。"
                },
                "step2": {
                    "name": "選擇比例",
                    "text": "選擇比原圖更適合目標平台的新比例，例如 9:16 或 16:9。"
                },
                "step3": {
                    "name": "AI 產生",
                    "text": "點擊「建立」，AI 會延展畫布並智慧補全空白區域，生成適配新比例的圖片。"
                }
            }
        }
    },
    "pl": {
        "aiImageResizer": {
            "title": "Darmowy AI Resizer Zdjęć Online | WeryAI",
            "description": "Zmieniaj rozmiar obrazów dla Instagramu, TikToka i YouTube bez przycinania. AI naturalnie rozszerza tło i zachowuje główny obiekt. Darmowe kredyty po rejestracji, bez karty.",
            "keywords": "zmiana rozmiaru obrazu, resizer zdjęć, zmiana proporcji obrazu, bez przycinania, rozmiar zdjęć social media, rozmiar Instagram, rozmiar TikTok, WeryAI",
            "og_title": "Darmowy AI Resizer Zdjęć Online | WeryAI",
            "og_description": "Zmieniaj rozmiar obrazów dla Instagramu, TikToka i YouTube bez przycinania. AI naturalnie rozszerza tło i zachowuje główny obiekt. Darmowe kredyty po rejestracji, bez karty.",
            "twitter_title": "Darmowy AI Resizer Zdjęć Online | WeryAI",
            "twitter_description": "Zmieniaj rozmiar obrazów dla Instagramu, TikToka i YouTube bez przycinania. AI naturalnie rozszerza tło i zachowuje główny obiekt. Darmowe kredyty po rejestracji, bez karty.",
            "page": {
                "title1": "Zmieniaj rozmiar bez przycinania",
                "title2": "Dopasuj zdjęcia do 9:16, 1:1, 16:9 i innych formatów bez wycinania głównego obiektu. WeryAI rozszerza płótno z pomocą AI i naturalnie uzupełnia tło.",
                "faq": [
                    {
                        "question": "Jak zmienić rozmiar obrazu bez przycinania?",
                        "answer": "Użyj AI Image Resizer od WeryAI. Prześlij zdjęcie, wybierz docelowe proporcje, a AI rozszerzy brakujące obszary tła zamiast przycinać obraz."
                    },
                    {
                        "question": "Czym jest AI outpainting przy zmianie rozmiaru obrazu?",
                        "answer": "AI outpainting rozszerza płótno, generując nowe tło dopasowane do światła, tekstury i stylu oryginalnego obrazu."
                    },
                    {
                        "question": "Czy mogę zmienić zdjęcie poziome na pionowe?",
                        "answer": "Tak. Prześlij zdjęcie poziome i wybierz pionowe proporcje, np. 9:16. AI automatycznie rozszerzy górę i dół kadru."
                    },
                    {
                        "question": "Czy rozszerzone tło będzie wyglądać sztucznie?",
                        "answer": "WeryAI korzysta z zaawansowanych modeli generatywnych trenowanych na ogromnych zbiorach danych, dzięki czemu rozszerzone tło naturalnie wtapia się w oryginalne oświetlenie i teksturę."
                    },
                    {
                        "question": "Czy mogę korzystać z WeryAI AI Image Resizer za darmo?",
                        "answer": "Tak. Nowi użytkownicy otrzymują darmowe kredyty po rejestracji bez karty kredytowej. Możesz też zdobywać kolejne darmowe kredyty dzięki codziennemu check-inowi, zadaniom i zapraszaniu znajomych, dzięki czemu możesz korzystać z narzędzia bez konieczności płacenia z góry."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Jak zmienić rozmiar obrazu bez przycinania?",
                    "answer": "Użyj AI Image Resizer od WeryAI. Prześlij zdjęcie, wybierz docelowe proporcje, a AI rozszerzy brakujące obszary tła zamiast przycinać obraz."
                },
                {
                    "question": "Czym jest AI outpainting przy zmianie rozmiaru obrazu?",
                    "answer": "AI outpainting rozszerza płótno, generując nowe tło dopasowane do światła, tekstury i stylu oryginalnego obrazu."
                },
                {
                    "question": "Czy mogę zmienić zdjęcie poziome na pionowe?",
                    "answer": "Tak. Prześlij zdjęcie poziome i wybierz pionowe proporcje, np. 9:16. AI automatycznie rozszerzy górę i dół kadru."
                },
                {
                    "question": "Czy rozszerzone tło będzie wyglądać sztucznie?",
                    "answer": "WeryAI korzysta z zaawansowanych modeli generatywnych trenowanych na ogromnych zbiorach danych, dzięki czemu rozszerzone tło naturalnie wtapia się w oryginalne oświetlenie i teksturę."
                },
                {
                    "question": "Czy mogę korzystać z WeryAI AI Image Resizer za darmo?",
                    "answer": "Tak. Nowi użytkownicy otrzymują darmowe kredyty po rejestracji bez karty kredytowej. Możesz też zdobywać kolejne darmowe kredyty dzięki codziennemu check-inowi, zadaniom i zapraszaniu znajomych, dzięki czemu możesz korzystać z narzędzia bez konieczności płacenia z góry."
                }
            ],
            "feature_title1": "Inteligentne rozszerzanie tła",
            "feature_desc1": "Magiczne wypełnianie: AI rozumie kontekst obrazu i rysuje nowe piksele poza oryginalnymi krawędziami. Krajobraz, wnętrze czy tekstura — rozszerzenie zawsze wygląda naturalnie i spójnie z oryginałem.",
            "feature_title2": "Ochrona głównego obiektu",
            "feature_desc2": "Nigdy nie przycinaj głównego motywu: AI automatycznie identyfikuje główną osobę lub obiekt i blokuje je w centrum kadru, gwarantując, że nic ważnego nie zostanie ucięte podczas zmiany rozmiaru.",
            "feature_title3": "Gotowe do social mediów",
            "feature_desc3": "Gotowe presety dla Instagram Stories (9:16), miniatur YouTube (16:9) i postów (4:5). Zaadaptuj treści na wszystkie platformy jednym kliknięciem.",
            "howto": {
                "name": "Jak zmienić rozmiar obrazów dla dowolnych proporcji",
                "step1": {
                    "name": "Prześlij obraz",
                    "text": "Prześlij zdjęcie do WeryAI Image Resizer."
                },
                "step2": {
                    "name": "Wybierz proporcje",
                    "text": "Wybierz nowe proporcje większe niż oryginalne, np. 9:16 lub 16:9."
                },
                "step3": {
                    "name": "Generuj z AI",
                    "text": "Kliknij Utwórz. AI rozszerzy płótno i wypełni dodatkową przestrzeń detalami tła."
                }
            }
        }
    },
    "th": {
        "aiImageResizer": {
            "title": "ปรับขนาดรูปภาพ AI ฟรี | WeryAI",
            "description": "ปรับขนาดรูปภาพสำหรับ Instagram, TikTok และ YouTube โดยไม่ต้องครอป AI จะขยายพื้นหลังอย่างเป็นธรรมชาติและคงองค์ประกอบหลักไว้ สมัครรับเครดิตฟรีได้โดยไม่ต้องใช้บัตร",
            "keywords": "ปรับขนาดรูปภาพ, เปลี่ยนขนาดภาพ, เปลี่ยนอัตราส่วนภาพ, ปรับขนาดโดยไม่ครอป, ขนาดรูปโซเชียลมีเดีย, ขนาด Instagram, ขนาด TikTok, WeryAI",
            "og_title": "ปรับขนาดรูปภาพ AI ฟรี | WeryAI",
            "og_description": "ปรับขนาดรูปภาพสำหรับ Instagram, TikTok และ YouTube โดยไม่ต้องครอป AI จะขยายพื้นหลังอย่างเป็นธรรมชาติและคงองค์ประกอบหลักไว้ สมัครรับเครดิตฟรีได้โดยไม่ต้องใช้บัตร",
            "twitter_title": "ปรับขนาดรูปภาพ AI ฟรี | WeryAI",
            "twitter_description": "ปรับขนาดรูปภาพสำหรับ Instagram, TikTok และ YouTube โดยไม่ต้องครอป AI จะขยายพื้นหลังอย่างเป็นธรรมชาติและคงองค์ประกอบหลักไว้ สมัครรับเครดิตฟรีได้โดยไม่ต้องใช้บัตร",
            "page": {
                "title1": "ปรับขนาดภาพโดยไม่ต้องครอป",
                "title2": "ปรับรูปของคุณให้เข้ากับ 9:16, 1:1, 16:9 และอีกหลายสัดส่วน โดยไม่ตัดวัตถุหลักออก WeryAI ใช้ AI ขยายผืนภาพและเติมพื้นหลังให้ดูกลมกลืนอย่างเป็นธรรมชาติ",
                "faq": [
                    {
                        "question": "ฉันจะปรับขนาดรูปโดยไม่ครอปได้อย่างไร",
                        "answer": "ใช้ AI Image Resizer ของ WeryAI อัปโหลดรูป เลือกสัดส่วนปลายทาง แล้ว AI จะขยายพื้นที่พื้นหลังที่ขาดไปแทนการครอปรูปของคุณ"
                    },
                    {
                        "question": "AI outpainting ในการปรับขนาดรูปคืออะไร",
                        "answer": "AI outpainting คือการขยายผืนภาพโดยสร้างพื้นหลังใหม่ให้เข้ากับแสง พื้นผิว และสไตล์ของรูปต้นฉบับอย่างเป็นธรรมชาติ"
                    },
                    {
                        "question": "ฉันสามารถเปลี่ยนรูปแนวนอนให้เป็นแนวตั้งได้ไหม",
                        "answer": "ได้ อัปโหลดรูปแนวนอนแล้วเลือกสัดส่วนแนวตั้งอย่าง 9:16 จากนั้น AI จะขยายด้านบนและด้านล่างให้เอง"
                    },
                    {
                        "question": "พื้นหลังที่ขยายออกจะดูปลอมไหม?",
                        "answer": "WeryAI ใช้โมเดล Generative AI ขั้นสูงที่ผ่านการฝึกฝนจากชุดข้อมูลขนาดใหญ่ เพื่อให้พื้นหลังที่ขยายออกกลมกลืนกับแสงและพื้นผิวของภาพต้นฉบับอย่างเป็นธรรมชาติ"
                    },
                    {
                        "question": "ฉันใช้ WeryAI AI Image Resizer ได้ฟรีไหม?",
                        "answer": "ได้ ผู้ใช้ใหม่จะได้รับเครดิตฟรีเมื่อสมัครใช้งานโดยไม่ต้องใช้บัตรเครดิต และยังรับเครดิตฟรีเพิ่มได้จากการเช็กอินรายวัน ทำภารกิจ และชวนเพื่อน จึงใช้เครื่องมือได้ต่อเนื่องโดยไม่ต้องจ่ายล่วงหน้า"
                    }
                ]
            },
            "faq": [
                {
                    "question": "ฉันจะปรับขนาดรูปโดยไม่ครอปได้อย่างไร?",
                    "answer": "ใช้ AI Image Resizer ของ WeryAI อัปโหลดรูป เลือกสัดส่วนปลายทาง แล้ว AI จะขยายพื้นที่พื้นหลังที่ขาดไปแทนการครอปรูปของคุณ"
                },
                {
                    "question": "AI outpainting ในการปรับขนาดรูปคืออะไร?",
                    "answer": "AI outpainting คือการขยายผืนภาพโดยสร้างพื้นหลังใหม่ให้เข้ากับแสง พื้นผิว และสไตล์ของรูปต้นฉบับอย่างเป็นธรรมชาติ"
                },
                {
                    "question": "ฉันสามารถเปลี่ยนรูปแนวนอนให้เป็นแนวตั้งได้ไหม?",
                    "answer": "ได้ อัปโหลดรูปแนวนอนแล้วเลือกสัดส่วนแนวตั้งอย่าง 9:16 จากนั้น AI จะขยายด้านบนและด้านล่างให้เอง"
                },
                {
                    "question": "พื้นหลังที่ขยายออกจะดูปลอมไหม?",
                    "answer": "WeryAI ใช้โมเดล Generative AI ขั้นสูงที่ผ่านการฝึกฝนจากชุดข้อมูลขนาดใหญ่ เพื่อให้พื้นหลังที่ขยายออกกลมกลืนกับแสงและพื้นผิวของภาพต้นฉบับอย่างเป็นธรรมชาติ"
                },
                {
                    "question": "ฉันใช้ WeryAI AI Image Resizer ได้ฟรีไหม?",
                    "answer": "ได้ ผู้ใช้ใหม่จะได้รับเครดิตฟรีเมื่อสมัครใช้งานโดยไม่ต้องใช้บัตรเครดิต และยังรับเครดิตฟรีเพิ่มได้จากการเช็กอินรายวัน ทำภารกิจ และชวนเพื่อน จึงใช้เครื่องมือได้ต่อเนื่องโดยไม่ต้องจ่ายล่วงหน้า"
                }
            ],
            "feature_title1": "ขยายพื้นหลังอย่างชาญฉลาด",
            "feature_desc1": "Magic Outpainting: AI เข้าใจบริบทของภาพและวาดพิกเซลใหม่ให้เลยขอบเดิมออกไป ไม่ว่าจะเป็นวิว ห้อง หรือพื้นผิว ก็ขยายได้อย่างกลมกลืนเพื่อเติมเต็มเฟรม",
            "feature_title2": "ปกป้องวัตถุหลัก",
            "feature_desc2": "ไม่ครอปตัวแบบอีกต่อไป: AI จะระบุคนหรือวัตถุหลักโดยอัตโนมัติและล็อกไว้ตรงกลาง เพื่อให้มั่นใจว่าตัวแบบจะไม่ถูกตัดออกขณะปรับขนาด",
            "feature_title3": "พร้อมสำหรับโซเชียลมีเดีย",
            "feature_desc3": "พรีเซ็ตสำเร็จรูปสำหรับ Instagram Stories (9:16), YouTube Thumbnails (16:9) และ Posts (4:5) ปรับคอนเทนต์ให้เข้ากับทุกแพลตฟอร์มในคลิกเดียว",
            "howto": {
                "name": "วิธีปรับขนาดรูปภาพให้เข้ากับทุกสัดส่วน",
                "step1": {
                    "name": "อัปโหลดรูปภาพ",
                    "text": "อัปโหลดรูปของคุณไปที่ WeryAI Image Resizer"
                },
                "step2": {
                    "name": "เลือกสัดส่วน",
                    "text": "เลือกสัดส่วนใหม่ที่ใหญ่กว่าต้นฉบับ เช่น 9:16 หรือ 16:9"
                },
                "step3": {
                    "name": "สร้างด้วย AI",
                    "text": "คลิก สร้าง แล้ว AI จะขยายผืนภาพและเติมพื้นที่ว่างด้วยรายละเอียดพื้นหลังที่เหมาะสม"
                }
            }
        }
    },
    "da": {
        "aiImageResizer": {
            "title": "Gratis AI Billedskalering Online | WeryAI",
            "description": "Tilpas billeder til Instagram, TikTok og YouTube uden beskæring. AI udvider baggrunden naturligt og bevarer motivet. Gratis credits ved registrering, intet kort kræves.",
            "keywords": "ændre billedstørrelse, billede resizer, ændre billedformat, uden beskæring, størrelse til sociale medier, Instagram størrelse, TikTok størrelse, WeryAI",
            "og_title": "Gratis AI Billedskalering Online | WeryAI",
            "og_description": "Tilpas billeder til Instagram, TikTok og YouTube uden beskæring. AI udvider baggrunden naturligt og bevarer motivet. Gratis credits ved registrering, intet kort kræves.",
            "twitter_title": "Gratis AI Billedskalering Online | WeryAI",
            "twitter_description": "Tilpas billeder til Instagram, TikTok og YouTube uden beskæring. AI udvider baggrunden naturligt og bevarer motivet. Gratis credits ved registrering, intet kort kræves.",
            "page": {
                "title1": "Tilpas billedstørrelse uden beskæring",
                "title2": "Gør dine billeder klar til 9:16, 1:1, 16:9 og andre formater uden at skære hovedmotivet væk. WeryAI udvider lærredet med AI og udfylder baggrunden naturligt.",
                "faq": [
                    {
                        "question": "Hvordan ændrer jeg billedstørrelsen uden beskæring?",
                        "answer": "Brug WeryAI AI Image Resizer. Upload dit billede, vælg målformatet, og AI udvider de manglende baggrundsområder i stedet for at beskære billedet."
                    },
                    {
                        "question": "Hvad er AI outpainting ved billedskalering?",
                        "answer": "AI outpainting udvider lærredet ved at generere ny baggrund, der matcher lys, tekstur og stil i det oprindelige billede."
                    },
                    {
                        "question": "Kan jeg gøre et vandret foto lodret?",
                        "answer": "Ja. Upload et vandret foto og vælg et lodret format som 9:16. AI udvider automatisk top og bund."
                    },
                    {
                        "question": "Vil den udvidede baggrund se falsk ud?",
                        "answer": "WeryAI bruger avancerede generative modeller trænet på enorme datasæt for at sikre, at den udvidede baggrund blender naturligt med det originale lys og den originale tekstur."
                    },
                    {
                        "question": "Kan jeg bruge WeryAI AI Image Resizer gratis?",
                        "answer": "Ja. Nye brugere får gratis credits ved registrering uden kreditkort. Du kan også få flere gratis credits via dagligt check-in, opgaver og invitationer af venner, så du kan fortsætte med at bruge værktøjet uden forudbetaling."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Hvordan ændrer jeg billedstørrelsen uden beskæring?",
                    "answer": "Brug WeryAI AI Image Resizer. Upload dit billede, vælg målformatet, og AI udvider de manglende baggrundsområder i stedet for at beskære billedet."
                },
                {
                    "question": "Hvad er AI outpainting ved billedskalering?",
                    "answer": "AI outpainting udvider lærredet ved at generere ny baggrund, der matcher lys, tekstur og stil i det oprindelige billede."
                },
                {
                    "question": "Kan jeg gøre et vandret foto lodret?",
                    "answer": "Ja. Upload et vandret foto og vælg et lodret format som 9:16. AI udvider automatisk top og bund."
                },
                {
                    "question": "Vil den udvidede baggrund se falsk ud?",
                    "answer": "WeryAI bruger avancerede generative modeller trænet på enorme datasæt for at sikre, at den udvidede baggrund blender naturligt med det originale lys og den originale tekstur."
                },
                {
                    "question": "Kan jeg bruge WeryAI AI Image Resizer gratis?",
                    "answer": "Ja. Nye brugere får gratis credits ved registrering uden kreditkort. Du kan også få flere gratis credits via dagligt check-in, opgaver og invitationer af venner, så du kan fortsætte med at bruge værktøjet uden forudbetaling."
                }
            ],
            "feature_title1": "Smart baggrundsudvidelse",
            "feature_desc1": "Magisk outpainting: AI forstår konteksten i dit billede og tegner nye pixels ud over de originale kanter. Udvid landskaber, rum eller teksturer problemfrit for at fylde rammen.",
            "feature_title2": "Beskyttelse af hovedmotivet",
            "feature_desc2": "Beskær aldrig motivet: Vores AI identificerer automatisk den vigtigste person eller genstand og låser den i centrum, så intet vigtigt klippes væk under størrelsesændringen.",
            "feature_title3": "Klar til sociale medier",
            "feature_desc3": "Forudindstillinger med ét klik til Instagram Stories (9:16), YouTube Thumbnails (16:9) og opslag (4:5). Tilpas dit indhold til alle platforme med det samme.",
            "howto": {
                "name": "Sådan tilpasser du billeder til ethvert format",
                "step1": {
                    "name": "Upload billede",
                    "text": "Upload dit foto til WeryAI Image Resizer."
                },
                "step2": {
                    "name": "Vælg format",
                    "text": "Vælg et nyt format, der er større end originalen, fx 9:16 eller 16:9."
                },
                "step3": {
                    "name": "Generer med AI",
                    "text": "Klik på Opret. AI udvider lærredet og fylder den ekstra plads med baggrundsdetaljer."
                }
            }
        }
    },
    "no": {
        "aiImageResizer": {
            "title": "Gratis AI Bildestørrelse Online | WeryAI",
            "description": "Endre bildestørrelse for Instagram, TikTok og YouTube uten beskjæring. AI utvider bakgrunnen naturlig og bevarer motivet. Gratis kreditter ved registrering, uten kort.",
            "keywords": "endre bildestørrelse, bilde resizer, endre bildeforhold, uten beskjæring, størrelse for sosiale medier, Instagram størrelse, TikTok størrelse, WeryAI",
            "og_title": "Gratis AI Bildestørrelse Online | WeryAI",
            "og_description": "Endre bildestørrelse for Instagram, TikTok og YouTube uten beskjæring. AI utvider bakgrunnen naturlig og bevarer motivet. Gratis kreditter ved registrering, uten kort.",
            "twitter_title": "Gratis AI Bildestørrelse Online | WeryAI",
            "twitter_description": "Endre bildestørrelse for Instagram, TikTok og YouTube uten beskjæring. AI utvider bakgrunnen naturlig og bevarer motivet. Gratis kreditter ved registrering, uten kort.",
            "page": {
                "title1": "Endre bildestørrelse uten beskjæring",
                "title2": "Tilpass bilder til 9:16, 1:1, 16:9 og andre formater uten å kutte bort hovedmotivet. WeryAI utvider lerretet med AI og fyller bakgrunnen naturlig inn.",
                "faq": [
                    {
                        "question": "Hvordan endrer jeg bildestørrelse uten å beskjære?",
                        "answer": "Bruk WeryAI AI Image Resizer. Last opp bildet ditt, velg målforholdet, og AI vil utvide manglende bakgrunnsområder i stedet for å beskjære bildet."
                    },
                    {
                        "question": "Hva er AI outpainting ved endring av bildestørrelse?",
                        "answer": "AI outpainting utvider lerretet ved å generere ny bakgrunn som matcher lys, tekstur og stil i originalbildet."
                    },
                    {
                        "question": "Kan jeg gjøre et horisontalt bilde vertikalt?",
                        "answer": "Ja. Last opp et horisontalt bilde og velg et vertikalt format som 9:16. AI utvider automatisk topp og bunn."
                    },
                    {
                        "question": "Vil den utvidede bakgrunnen se falsk ut?",
                        "answer": "WeryAI bruker avanserte generative modeller trent på massive datasett for å sikre at den utvidede bakgrunnen blender naturlig med originalbildets lys og tekstur."
                    },
                    {
                        "question": "Kan jeg bruke WeryAI AI Image Resizer gratis?",
                        "answer": "Ja. Nye brukere får gratis kreditter ved registrering uten kredittkort. Du kan også få flere gratis kreditter gjennom daglig innsjekk, oppgaver og venninvitasjoner, slik at du kan fortsette å bruke verktøyet uten forhåndsbetaling."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Hvordan endrer jeg bildestørrelse uten å beskjære?",
                    "answer": "Bruk WeryAI AI Image Resizer. Last opp bildet ditt, velg målforholdet, og AI vil utvide manglende bakgrunnsområder i stedet for å beskjære bildet."
                },
                {
                    "question": "Hva er AI outpainting ved endring av bildestørrelse?",
                    "answer": "AI outpainting utvider lerretet ved å generere ny bakgrunn som matcher lys, tekstur og stil i originalbildet."
                },
                {
                    "question": "Kan jeg gjøre et horisontalt bilde vertikalt?",
                    "answer": "Ja. Last opp et horisontalt bilde og velg et vertikalt format som 9:16. AI utvider automatisk topp og bunn."
                },
                {
                    "question": "Vil den utvidede bakgrunnen se falsk ut?",
                    "answer": "WeryAI bruker avanserte generative modeller trent på massive datasett for å sikre at den utvidede bakgrunnen blender naturlig med originalbildets lys og tekstur."
                },
                {
                    "question": "Kan jeg bruke WeryAI AI Image Resizer gratis?",
                    "answer": "Ja. Nye brukere får gratis kreditter ved registrering uten kredittkort. Du kan også få flere gratis kreditter gjennom daglig innsjekk, oppgaver og venninvitasjoner, slik at du kan fortsette å bruke verktøyet uten forhåndsbetaling."
                }
            ],
            "feature_title1": "Smart bakgrunnsutvidelse",
            "feature_desc1": "Magisk outpainting: AI forstår konteksten i bildet ditt og tegner nye piksler utenfor de opprinnelige kantene. Utvid landskap, rom eller teksturer sømløst for å fylle rammen.",
            "feature_title2": "Beskyttelse av hovedmotivet",
            "feature_desc2": "Aldri beskjær motivet: AI identifiserer automatisk hovedpersonen eller objektet og låser det i sentrum, slik at ingenting viktig kuttes bort under størrelsesendringen.",
            "feature_title3": "Klar for sosiale medier",
            "feature_desc3": "Forhåndsinnstillinger med ett klikk for Instagram Stories (9:16), YouTube Thumbnails (16:9) og innlegg (4:5). Tilpass innholdet ditt til alle plattformer umiddelbart.",
            "howto": {
                "name": "Slik endrer du bildestørrelse for alle formater",
                "step1": {
                    "name": "Last opp bilde",
                    "text": "Last opp bildet ditt til WeryAI Image Resizer."
                },
                "step2": {
                    "name": "Velg format",
                    "text": "Velg et nytt format som er større enn originalen, for eksempel 9:16 eller 16:9."
                },
                "step3": {
                    "name": "Generer med AI",
                    "text": "Klikk på Opprett. AI utvider lerretet og fyller ekstra plass med bakgrunnsdetaljer."
                }
            }
        }
    },
    "nl": {
        "aiImageResizer": {
            "title": "Gratis AI Afbeelding Resizer | WeryAI",
            "description": "Pas afbeeldingen aan voor Instagram, TikTok en YouTube zonder bij te snijden. AI breidt de achtergrond natuurlijk uit en houdt het hoofdonderwerp intact. Gratis credits bij registratie, geen kaart nodig.",
            "keywords": "afbeelding formaat wijzigen, image resizer, beeldverhouding wijzigen, zonder bijsnijden, formaat sociale media, Instagram formaat, TikTok formaat, WeryAI",
            "og_title": "Gratis AI Afbeelding Resizer | WeryAI",
            "og_description": "Pas afbeeldingen aan voor Instagram, TikTok en YouTube zonder bij te snijden. AI breidt de achtergrond natuurlijk uit en houdt het hoofdonderwerp intact. Gratis credits bij registratie, geen kaart nodig.",
            "twitter_title": "Gratis AI Afbeelding Resizer | WeryAI",
            "twitter_description": "Pas afbeeldingen aan voor Instagram, TikTok en YouTube zonder bij te snijden. AI breidt de achtergrond natuurlijk uit en houdt het hoofdonderwerp intact. Gratis credits bij registratie, geen kaart nodig.",
            "page": {
                "title1": "Formaat wijzigen zonder bijsnijden",
                "title2": "Maak je foto geschikt voor 9:16, 1:1, 16:9 en meer zonder het hoofdonderwerp weg te snijden. WeryAI vergroot het canvas met AI en vult de achtergrond natuurlijk aan.",
                "faq": [
                    {
                        "question": "Hoe wijzig ik het formaat van een afbeelding zonder bij te snijden?",
                        "answer": "Gebruik WeryAI AI Image Resizer. Upload je foto, kies de doelverhouding en de AI vult ontbrekende achtergrondgebieden aan in plaats van de afbeelding bij te snijden."
                    },
                    {
                        "question": "Wat is AI outpainting bij het wijzigen van afbeeldingsformaat?",
                        "answer": "AI outpainting vergroot het canvas door nieuwe achtergrond te genereren die past bij het licht, de textuur en de stijl van de originele afbeelding."
                    },
                    {
                        "question": "Kan ik een horizontale foto verticaal maken?",
                        "answer": "Ja. Upload een horizontale foto en kies een verticale verhouding zoals 9:16. De AI breidt automatisch de boven- en onderkant uit."
                    },
                    {
                        "question": "Ziet de uitgebreide achtergrond er nep uit?",
                        "answer": "WeryAI gebruikt geavanceerde generatieve modellen die zijn getraind op enorme datasets om ervoor te zorgen dat de uitgebreide achtergrond natuurlijk aansluit bij de oorspronkelijke belichting en textuur."
                    },
                    {
                        "question": "Kan ik WeryAI AI Image Resizer gratis gebruiken?",
                        "answer": "Ja. Nieuwe gebruikers krijgen gratis credits bij registratie zonder creditcard. Je kunt ook extra gratis credits verdienen via dagelijkse check-in, taken en vrienden uitnodigen, zodat je het hulpmiddel kunt blijven gebruiken zonder vooruitbetaling."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Hoe wijzig ik het formaat van een afbeelding zonder bij te snijden?",
                    "answer": "Gebruik WeryAI AI Image Resizer. Upload je foto, kies de doelverhouding en de AI vult ontbrekende achtergrondgebieden aan in plaats van de afbeelding bij te snijden."
                },
                {
                    "question": "Wat is AI outpainting bij het wijzigen van afbeeldingsformaat?",
                    "answer": "AI outpainting vergroot het canvas door nieuwe achtergrond te genereren die past bij het licht, de textuur en de stijl van de originele afbeelding."
                },
                {
                    "question": "Kan ik een horizontale foto verticaal maken?",
                    "answer": "Ja. Upload een horizontale foto en kies een verticale verhouding zoals 9:16. De AI breidt automatisch de boven- en onderkant uit."
                },
                {
                    "question": "Ziet de uitgebreide achtergrond er nep uit?",
                    "answer": "WeryAI gebruikt geavanceerde generatieve modellen die zijn getraind op enorme datasets om ervoor te zorgen dat de uitgebreide achtergrond natuurlijk aansluit bij de oorspronkelijke belichting en textuur."
                },
                {
                    "question": "Kan ik WeryAI AI Image Resizer gratis gebruiken?",
                    "answer": "Ja. Nieuwe gebruikers krijgen gratis credits bij registratie zonder creditcard. Je kunt ook extra gratis credits verdienen via dagelijkse check-in, taken en vrienden uitnodigen, zodat je het hulpmiddel kunt blijven gebruiken zonder vooruitbetaling."
                }
            ],
            "feature_title1": "Slimme achtergronduitbreiding",
            "feature_desc1": "Magische outpainting: de AI begrijpt de context van je afbeelding en tekent nieuwe pixels voorbij de originele randen. Breid landschappen, kamers of texturen naadloos uit om het kader te vullen.",
            "feature_title2": "Bescherming van het hoofdonderwerp",
            "feature_desc2": "Snijd nooit het onderwerp bij: onze AI identificeert automatisch de belangrijkste persoon of het belangrijkste object en vergrendelt deze in het midden, zodat er niets verloren gaat tijdens het wijzigen van het formaat.",
            "feature_title3": "Klaar voor sociale media",
            "feature_desc3": "Presets met één klik voor Instagram Stories (9:16), YouTube Thumbnails (16:9) en berichten (4:5). Hergebruik je content voor alle platformen in een handomdraai.",
            "howto": {
                "name": "Zo wijzig je afbeeldingen voor elke beeldverhouding",
                "step1": {
                    "name": "Afbeelding uploaden",
                    "text": "Upload je foto naar WeryAI Image Resizer."
                },
                "step2": {
                    "name": "Verhouding kiezen",
                    "text": "Kies een nieuwe verhouding groter dan het origineel, zoals 9:16 of 16:9."
                },
                "step3": {
                    "name": "Genereren met AI",
                    "text": "Klik op Maken. De AI vergroot het canvas en vult de extra ruimte met achtergronddetails."
                }
            }
        }
    },
    "id": {
        "aiImageResizer": {
            "title": "Pengubah Ukuran Gambar AI Gratis | WeryAI",
            "description": "Ubah ukuran gambar untuk Instagram, TikTok, dan YouTube tanpa crop. AI memperluas latar belakang secara alami dan menjaga subjek utama tetap utuh. Kredit gratis saat mendaftar, tanpa kartu.",
            "keywords": "ubah ukuran gambar, image resizer, ubah rasio gambar, tanpa crop, ukuran gambar media sosial, ukuran Instagram, ukuran TikTok, WeryAI",
            "og_title": "Pengubah Ukuran Gambar AI Gratis | WeryAI",
            "og_description": "Ubah ukuran gambar untuk Instagram, TikTok, dan YouTube tanpa crop. AI memperluas latar belakang secara alami dan menjaga subjek utama tetap utuh. Kredit gratis saat mendaftar, tanpa kartu.",
            "twitter_title": "Pengubah Ukuran Gambar AI Gratis | WeryAI",
            "twitter_description": "Ubah ukuran gambar untuk Instagram, TikTok, dan YouTube tanpa crop. AI memperluas latar belakang secara alami dan menjaga subjek utama tetap utuh. Kredit gratis saat mendaftar, tanpa kartu.",
            "page": {
                "title1": "Ubah ukuran gambar tanpa crop",
                "title2": "Sesuaikan foto ke 9:16, 1:1, 16:9, dan format lain tanpa memotong subjek utama. WeryAI memperluas kanvas dengan AI dan mengisi latar belakang secara alami.",
                "faq": [
                    {
                        "question": "Bagaimana cara mengubah ukuran gambar tanpa crop?",
                        "answer": "Gunakan AI Image Resizer dari WeryAI. Unggah foto Anda, pilih rasio tujuan, lalu AI akan memperluas area latar yang kurang alih-alih memotong gambar."
                    },
                    {
                        "question": "Apa itu AI outpainting saat mengubah ukuran gambar?",
                        "answer": "AI outpainting memperbesar kanvas dengan menghasilkan latar belakang baru yang sesuai dengan cahaya, tekstur, dan gaya gambar asli."
                    },
                    {
                        "question": "Bisakah saya mengubah foto horizontal menjadi vertikal?",
                        "answer": "Bisa. Unggah foto horizontal dan pilih rasio vertikal seperti 9:16. AI akan memperluas bagian atas dan bawah secara otomatis."
                    },
                    {
                        "question": "Apakah latar belakang yang diperluas akan terlihat palsu?",
                        "answer": "WeryAI menggunakan model generatif canggih yang dilatih pada kumpulan data besar untuk memastikan latar belakang yang diperluas menyatu secara alami dengan pencahayaan dan tekstur asli."
                    },
                    {
                        "question": "Bisakah saya menggunakan WeryAI AI Image Resizer secara gratis?",
                        "answer": "Ya. Pengguna baru mendapatkan kredit gratis saat mendaftar tanpa kartu kredit. Anda juga bisa mendapatkan lebih banyak kredit gratis melalui check-in harian, menyelesaikan tugas, dan mengundang teman, sehingga Anda bisa terus menggunakan alat ini tanpa pembayaran di muka."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Bagaimana cara mengubah ukuran gambar tanpa crop?",
                    "answer": "Gunakan AI Image Resizer dari WeryAI. Unggah foto Anda, pilih rasio tujuan, lalu AI akan memperluas area latar yang kurang alih-alih memotong gambar."
                },
                {
                    "question": "Apa itu AI outpainting saat mengubah ukuran gambar?",
                    "answer": "AI outpainting memperbesar kanvas dengan menghasilkan latar belakang baru yang sesuai dengan cahaya, tekstur, dan gaya gambar asli."
                },
                {
                    "question": "Bisakah saya mengubah foto horizontal menjadi vertikal?",
                    "answer": "Bisa. Unggah foto horizontal dan pilih rasio vertikal seperti 9:16. AI akan memperluas bagian atas dan bawah secara otomatis."
                },
                {
                    "question": "Apakah latar belakang yang diperluas akan terlihat palsu?",
                    "answer": "WeryAI menggunakan model generatif canggih yang dilatih pada kumpulan data besar untuk memastikan latar belakang yang diperluas menyatu secara alami dengan pencahayaan dan tekstur asli."
                },
                {
                    "question": "Bisakah saya menggunakan WeryAI AI Image Resizer secara gratis?",
                    "answer": "Ya. Pengguna baru mendapatkan kredit gratis saat mendaftar tanpa kartu kredit. Anda juga bisa mendapatkan lebih banyak kredit gratis melalui check-in harian, menyelesaikan tugas, dan mengundang teman, sehingga Anda bisa terus menggunakan alat ini tanpa pembayaran di muka."
                }
            ],
            "feature_title1": "Perluasan latar belakang cerdas",
            "feature_desc1": "Magic Outpainting: AI memahami konteks gambar Anda dan menggambar piksel baru di luar batas asli. Perluas lanskap, ruangan, atau tekstur dengan mulus untuk mengisi bingkai.",
            "feature_title2": "Perlindungan subjek utama",
            "feature_desc2": "Jangan pernah memotong subjek: AI kami secara otomatis mengidentifikasi orang atau objek utama dan menguncinya di tengah, memastikan tidak ada yang terpotong selama proses pengubahan ukuran.",
            "feature_title3": "Siap untuk media sosial",
            "feature_desc3": "Preset satu klik untuk Instagram Stories (9:16), YouTube Thumbnails (16:9), dan Posts (4:5). Adaptasi konten Anda ke semua platform secara instan.",
            "howto": {
                "name": "Cara mengubah ukuran gambar untuk rasio apa pun",
                "step1": {
                    "name": "Unggah gambar",
                    "text": "Unggah foto Anda ke WeryAI Image Resizer."
                },
                "step2": {
                    "name": "Pilih rasio",
                    "text": "Pilih rasio baru yang lebih besar dari aslinya, seperti 9:16 atau 16:9."
                },
                "step3": {
                    "name": "Buat dengan AI",
                    "text": "Klik Buat. AI akan memperluas kanvas dan mengisi ruang tambahan dengan detail latar belakang."
                }
            }
        }
    },
    "tr": {
        "aiImageResizer": {
            "title": "Ücretsiz AI Görsel Yeniden Boyutlandırıcı | WeryAI",
            "description": "Görselleri Instagram, TikTok ve YouTube için kırpmadan yeniden boyutlandırın. AI arka planı doğal şekilde genişletir ve ana öğeyi korur. Kayıtta ücretsiz kredi, kart gerekmez.",
            "keywords": "görsel boyutlandırma, image resizer, en boy oranı değiştirme, kırpmadan boyutlandırma, sosyal medya görsel boyutu, Instagram boyutu, TikTok boyutu, WeryAI",
            "og_title": "Ücretsiz AI Görsel Yeniden Boyutlandırıcı | WeryAI",
            "og_description": "Görselleri Instagram, TikTok ve YouTube için kırpmadan yeniden boyutlandırın. AI arka planı doğal şekilde genişletir ve ana öğeyi korur. Kayıtta ücretsiz kredi, kart gerekmez.",
            "twitter_title": "Ücretsiz AI Görsel Yeniden Boyutlandırıcı | WeryAI",
            "twitter_description": "Görselleri Instagram, TikTok ve YouTube için kırpmadan yeniden boyutlandırın. AI arka planı doğal şekilde genişletir ve ana öğeyi korur. Kayıtta ücretsiz kredi, kart gerekmez.",
            "page": {
                "title1": "Kırpmadan görsel boyutlandırın",
                "title2": "Fotoğraflarınızı 9:16, 1:1, 16:9 ve diğer oranlara ana öğeyi kesmeden uyarlayın. WeryAI tuvali AI ile genişletir ve arka planı doğal şekilde tamamlar.",
                "faq": [
                    {
                        "question": "Bir görseli kırpmadan nasıl yeniden boyutlandırırım?",
                        "answer": "WeryAI AI Image Resizer aracını kullanın. Fotoğrafınızı yükleyin, hedef oranı seçin ve AI görseli kırpmak yerine eksik arka plan alanlarını genişletsin."
                    },
                    {
                        "question": "Görsel boyutlandırmada AI outpainting nedir?",
                        "answer": "AI outpainting, tuvali genişletip orijinal görselin ışık, doku ve stiline uyan yeni arka plan içeriği üretir."
                    },
                    {
                        "question": "Yatay bir fotoğrafı dikey hale getirebilir miyim?",
                        "answer": "Evet. Yatay fotoğrafı yükleyin ve 9:16 gibi dikey bir oran seçin. AI üst ve alt alanları otomatik olarak genişletir."
                    },
                    {
                        "question": "Genişletilen arka plan sahte görünecek mi?",
                        "answer": "WeryAI, genişletilen arka planın orijinal aydınlatma ve dokuyla doğal şekilde kaynaşmasını sağlamak için büyük veri kümeleriyle eğitilmiş gelişmiş üretken modeller kullanır."
                    },
                    {
                        "question": "WeryAI AI Image Resizer aracını ücretsiz kullanabilir miyim?",
                        "answer": "Evet. Yeni kullanıcılar kayıt sırasında kredi kartı gerekmeksizin ücretsiz kredi alır. Ayrıca günlük giriş, görev tamamlama ve arkadaş davetiyle daha fazla ücretsiz kredi kazanabilirsiniz; böylece ön ödeme yapmadan aracı kullanmaya devam edebilirsiniz."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Bir görseli kırpmadan nasıl yeniden boyutlandırırım?",
                    "answer": "WeryAI AI Image Resizer aracını kullanın. Fotoğrafınızı yükleyin, hedef oranı seçin ve AI görseli kırpmak yerine eksik arka plan alanlarını genişletsin."
                },
                {
                    "question": "Görsel boyutlandırmada AI outpainting nedir?",
                    "answer": "AI outpainting, tuvali genişletip orijinal görselin ışık, doku ve stiline uyan yeni arka plan içeriği üretir."
                },
                {
                    "question": "Yatay bir fotoğrafı dikey hale getirebilir miyim?",
                    "answer": "Evet. Yatay fotoğrafı yükleyin ve 9:16 gibi dikey bir oran seçin. AI üst ve alt alanları otomatik olarak genişletir."
                },
                {
                    "question": "Genişletilen arka plan sahte görünecek mi?",
                    "answer": "WeryAI, genişletilen arka planın orijinal aydınlatma ve dokuyla doğal şekilde kaynaşmasını sağlamak için büyük veri kümeleriyle eğitilmiş gelişmiş üretken modeller kullanır."
                },
                {
                    "question": "WeryAI AI Image Resizer aracını ücretsiz kullanabilir miyim?",
                    "answer": "Evet. Yeni kullanıcılar kayıt sırasında kredi kartı gerekmeksizin ücretsiz kredi alır. Ayrıca günlük giriş, görev tamamlama ve arkadaş davetiyle daha fazla ücretsiz kredi kazanabilirsiniz; böylece ön ödeme yapmadan aracı kullanmaya devam edebilirsiniz."
                }
            ],
            "feature_title1": "Akıllı arka plan genişletme",
            "feature_desc1": "Sihirli outpainting: AI görselinizin bağlamını anlar ve orijinal sınırların ötesine yeni pikseller çizer. Manzaraları, odaları veya dokuları çerçeveyi doldurmak için sorunsuz bir şekilde genişletin.",
            "feature_title2": "Ana öğeyi koruma",
            "feature_desc2": "Konuyu asla kırpmayın: AI, ana kişiyi veya nesneyi otomatik olarak tespit eder ve merkeze kilitler; böylece yeniden boyutlandırma sırasında hiçbir önemli öğe kesilmez.",
            "feature_title3": "Sosyal medya için hazır",
            "feature_desc3": "Instagram Stories (9:16), YouTube Thumbnails (16:9) ve gönderiler (4:5) için tek tıkla hazır ayarlar. İçeriğinizi tüm platformlara anında uyarlayın.",
            "howto": {
                "name": "Her oran için görsel boyutu nasıl değiştirilir",
                "step1": {
                    "name": "Görsel yükle",
                    "text": "Fotoğrafınızı WeryAI Image Resizer aracına yükleyin."
                },
                "step2": {
                    "name": "Oran seç",
                    "text": "Orijinalden daha büyük yeni bir oran seçin; örneğin 9:16 veya 16:9."
                },
                "step3": {
                    "name": "AI ile oluştur",
                    "text": "Oluştur’a tıklayın. AI tuvali genişletir ve ekstra alanı arka plan detaylarıyla doldurur."
                }
            }
        }
    }
}
